
(function() {
  'use strict';

  var NEWUX = window.CBMNewUX = window.CBMNewUX || {};
  var sessionCache = null;
  var sessionPromise = null;
  var NRED_URL = 'https://red.prod.secure.nv.gov/Lookup/LicenseLookup.aspx';

  function rootUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[\/|_+]+/g, ' ')
      .replace(/[^a-z0-9 -]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function licenseKey(value) {
    var n = normalize(value);
    var map = {
      'broker salesperson': 'broker-salesperson',
      'property management permit': 'property-management-permit',
      'business broker permit': 'business-broker-permit',
      'time share': 'timeshare'
    };
    return map[n] || n.replace(/\s+/g, '-');
  }

  function designationKey(value) {
    var n = normalize(value);
    var map = {
      'law and legislation': 'law-legislation',
      'law legislation': 'law-legislation',
      'risk reduction': 'risk-reduction',
      'property management': 'property-management',
      'broker management': 'broker-management',
      'business broker': 'business-broker'
    };
    return map[n] || n.replace(/\s+/g, '-');
  }

  function splitValues(card, name, mapper) {
    return String(card.getAttribute(name) || '')
      .split('||').map(function(v) { return mapper(v); }).filter(Boolean);
  }

  function moneyText(card) {
    var attr = card.getAttribute('data-cbm-newux-price');
    if (attr) return attr;
    var node = card.querySelector('[data-cbm-promotion-price], [class*="__price-"]');
    return node ? node.textContent.trim() : '';
  }

  function productTitle(card, button) {
    if (button && button.getAttribute('data-product-title')) return button.getAttribute('data-product-title');
    if (card && card.getAttribute('data-cbm-newux-title')) return card.getAttribute('data-cbm-newux-title');
    var title = card ? card.querySelector('[class*="__title-"]') : null;
    return title ? title.textContent.trim() : 'Course';
  }

  function bookingMode(button) {
    return button ? (button.getAttribute('data-live-booking-mode') || (button.getAttribute('data-live-date-required') === 'true' ? 'individual' : 'none')) : 'none';
  }

  function packageCodes(button) {
    var seen = {};
    return String(button && button.getAttribute('data-package-live-course-codes') || '')
      .split('||').map(function(v) { return v.trim(); }).filter(function(v) {
        if (!v || seen[v]) return false;
        seen[v] = true;
        return true;
      });
  }

  function catalogCourseIndices(codes) {
    function rank(code) { return code === 'CE.7027000-RE' ? -1 : code === 'CE.7085000-RE' ? 1 : 0; }
    return codes.map(function(code,index){return index;}).sort(function(a,b){
      return rank(codes[a])-rank(codes[b]) || a-b;
    });
  }

  function catalogMissingIndex(state,exclude) {
    var indices=catalogCourseIndices(state.codes);
    for(var i=0;i<indices.length;i++){
      if(indices[i]!==exclude && !state.selections[indices[i]])return indices[i];
    }
    return -1;
  }

  function scheduleUrl(catalog) {
    return catalog ? (catalog.getAttribute('data-live-schedule-url') || '') : '';
  }

  function loadSessions(catalog) {
    if (sessionCache) return Promise.resolve(sessionCache);
    if (sessionPromise) return sessionPromise;
    var url = scheduleUrl(catalog);
    if (!url) return Promise.reject(new Error('Class schedule is unavailable.'));
    sessionPromise = fetch(url, {credentials:'same-origin', cache:'no-store'})
      .then(function(r) {
        if (!r.ok) throw new Error('Unable to load class dates.');
        return r.json();
      })
      .then(function(data) {
        sessionCache = data || {courses:{}};
        return sessionCache;
      });
    return sessionPromise;
  }

  function upcomingEvents(courseCode) {
    if (!sessionCache || !sessionCache.courses || !sessionCache.courses[courseCode]) return [];
    return (sessionCache.courses[courseCode].events || []).filter(function(event) {
      return event && event.session_id && event.start && new Date(event.start).getTime() > Date.now();
    }).sort(function(a,b) { return new Date(a.start) - new Date(b.start); });
  }

  function courseName(code) {
    return sessionCache && sessionCache.courses && sessionCache.courses[code] && sessionCache.courses[code].title
      ? sessionCache.courses[code].title : code;
  }

  function pacificParts(iso) {
    var tz = sessionCache && sessionCache.timezone ? sessionCache.timezone : 'America/Los_Angeles';
    var d = new Date(iso);
    return {
      date: new Intl.DateTimeFormat('en-US', {timeZone:tz, weekday:'short', month:'short', day:'numeric', year:'numeric'}).format(d),
      time: new Intl.DateTimeFormat('en-US', {timeZone:tz, hour:'numeric', minute:'2-digit'}).format(d)
    };
  }

  function pacificMonthParts(value) {
    var tz = sessionCache && sessionCache.timezone ? sessionCache.timezone : 'America/Los_Angeles';
    var d = value instanceof Date ? value : new Date(value);
    var parts = new Intl.DateTimeFormat('en-US', {timeZone:tz, year:'numeric', month:'2-digit'}).formatToParts(d);
    var year = '';
    var month = '';
    parts.forEach(function(part) {
      if (part.type === 'year') year = part.value;
      if (part.type === 'month') month = part.value;
    });
    return {
      key: year + '-' + month,
      label: new Intl.DateTimeFormat('en-US', {timeZone:tz, month:'long', year:'numeric'}).format(d)
    };
  }

  function liveLabel(event) {
    var s = pacificParts(event.start);
    var e = pacificParts(event.end);
    return s.date + ' - ' + s.time + ' - ' + e.time;
  }

  function cartGate(task) {
    if (window.CBMCartMutationGate && typeof window.CBMCartMutationGate.run === 'function') {
      return window.CBMCartMutationGate.run(task);
    }
    return task();
  }

  function getCart() {
    return fetch(rootUrl('cart.js'), {cache:'no-store'}).then(function(r) {
      if (!r.ok) throw new Error('Unable to read your cart right now.');
      return r.json();
    });
  }

  function parseNevadaLicense(value) {
    var raw=String(value||'').trim().toUpperCase();
    var match=raw.match(/^(BS|B|S)\.(\d+)(?:\.(LLC|PC|CORP))?$/);
    if(!match)return {type:'',number:'',suffix:''};
    return {
      type:match[1]==='BS'?'Broker-Salesperson':match[1]==='B'?'Broker':'Salesperson',
      number:match[2]||'',
      suffix:match[3]||''
    };
  }

  function nevadaLicensePrefix(type) {
    if(type==='Broker-Salesperson')return 'BS.';
    if(type==='Broker')return 'B.';
    return 'S.';
  }

  function buildNevadaLicense(type,number) {
    var digits=String(number||'').trim();
    return digits?nevadaLicensePrefix(type)+digits:'';
  }

  function buildNevadaLicenseDisplay(type,number,suffix) {
    var base=buildNevadaLicense(type,number);
    var cleanSuffix=String(suffix||'').trim().toUpperCase();
    return base+(base&&cleanSuffix?'.'+cleanSuffix:'');
  }

  var PURCHASE_DRAFT_VERSION=1;
  var PURCHASE_DRAFT_PREFIX='cbm-newux-purchase-draft-v1:';
  var purchaseDraftMemory={};

  function purchaseDraftKey(variantId) {
    return PURCHASE_DRAFT_PREFIX+String(variantId||'');
  }

  function readPurchaseDraft(variantId) {
    var key=purchaseDraftKey(variantId);
    var raw='';
    try { raw=window.sessionStorage ? window.sessionStorage.getItem(key)||'' : ''; } catch(_) {}
    if(raw) {
      try {
        var parsed=JSON.parse(raw);
        if(parsed&&parsed.version===PURCHASE_DRAFT_VERSION)return parsed;
      } catch(_) {}
    }
    return purchaseDraftMemory[key]||null;
  }

  function writePurchaseDraft(variantId,draft) {
    var key=purchaseDraftKey(variantId);
    purchaseDraftMemory[key]=draft;
    try {
      if(window.sessionStorage)window.sessionStorage.setItem(key,JSON.stringify(draft));
    } catch(_) {}
    return true;
  }

  function clearPurchaseDraft(variantId) {
    var key=purchaseDraftKey(variantId);
    delete purchaseDraftMemory[key];
    try { if(window.sessionStorage)window.sessionStorage.removeItem(key); } catch(_) {}
  }

  function hasPurchaseDraft(variantId) {
    return !!readPurchaseDraft(variantId);
  }

  function notifyPurchaseDraftState(variantId) {
    document.dispatchEvent(new CustomEvent('cbm:purchase-draft-state',{detail:{variantId:String(variantId||'')}}));
  }

  window.CBMNewUxPurchaseDraft={
    hasDraft:function(variantId){return hasPurchaseDraft(variantId);}
  };

  function saveStudentAttributes(student) {
    student.license=buildNevadaLicense(student.licenseType,student.licenseNumber);
    student.displayLicense=buildNevadaLicenseDisplay(student.licenseType,student.licenseNumber,student.suffix);
    var attributes = {
      'CE Student Type': student.type,
      'CE License State': student.state||'Nevada',
      'CE License Type': student.licenseType||'',
      'CE License Number Digits': student.licenseNumber||'',
      'CE License Suffix': student.suffix||'',
      'Nevada License Number': student.license,
      'CE Student First Name': student.type === 'Different Licensee' ? student.first : '',
      'CE Student Last Name': student.type === 'Different Licensee' ? student.last : '',
      'CE Student Email': student.type === 'Different Licensee' ? student.email : ''
    };
    return cartGate(function() {
      return fetch(rootUrl('cart/update.js'), {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({attributes:attributes})
      }).then(function(r) {
        if (!r.ok) throw new Error('Unable to save student information.');
        return r.json();
      });
    });
  }

  function addItem(item) {
    return cartGate(function() {
      return fetch(rootUrl('cart/add.js'), {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[item]})
      }).then(function(r) {
        if (!r.ok) return r.json().catch(function(){ return {}; }).then(function(e) {
          throw new Error(e.description || e.message || 'Unable to add this course right now.');
        });
        return r.json();
      });
    });
  }

  function syncHeaderCartBubble(cart) {
    var link=document.getElementById('cart-icon-bubble');
    if(!link)return;
    var count=Math.max(0,Number(cart&&cart.item_count)||0);
    var bubble=link.querySelector('.cart-count-bubble');

    if(count<=0){
      if(bubble)bubble.remove();
      return;
    }

    if(!bubble){
      bubble=document.createElement('div');
      bubble.className='cart-count-bubble';
      bubble.innerHTML='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      link.appendChild(bubble);
    }

    var visible=bubble.querySelector('[aria-hidden="true"]');
    var accessible=bubble.querySelector('.visually-hidden');
    if(visible)visible.textContent=count<100?String(count):'99+';
    if(accessible)accessible.textContent=count+' '+(count===1?'item':'items')+' in cart';
  }

  function syncThemeCartState(cart,sourceElement) {
    if(!cart)return;
    syncHeaderCartBubble(cart);
    document.dispatchEvent(new CustomEvent('cbm:cart-state', {detail:{cart:cart}}));
    var drawer=document.querySelector('cart-drawer');
    if(drawer&&typeof drawer.refreshSilently==='function'){
      Promise.resolve(drawer.refreshSilently(sourceElement||null)).catch(function(){});
    }
  }

  function emitCartState(sourceElement) {
    return getCart().then(function(cart) {
      syncThemeCartState(cart,sourceElement);
      return cart;
    }).catch(function(){ return null; });
  }

  function initHomeFinder() {
    var finder = document.querySelector('[data-cbm-newux-home-finder]');
    if (!finder || finder.dataset.ready === 'true') return;
    finder.dataset.ready = 'true';
    var license = finder.querySelector('[data-cbm-newux-home-license]');
    var button = finder.querySelector('[data-cbm-newux-home-submit]');
    var status = finder.querySelector('[data-cbm-newux-home-status]');
    var targetUrl = finder.getAttribute('data-catalog-url') || '/pages/buy-courses';
    if (!button) return;

    if (license) {
      license.addEventListener('change', function() {
        if (status) status.textContent = '';
      });
    }

    button.addEventListener('click', function() {
      var selectedLicense = license ? license.value : '';
      if (!selectedLicense) {
        if (status) status.textContent = 'Choose a license to continue.';
        if (license) license.focus();
        return;
      }
      var url = new URL(targetUrl, window.location.origin);
      url.searchParams.set('state','nevada');
      url.searchParams.set('license',selectedLicense);
      window.location.href = url.pathname + url.search;
    });
  }

  function labelLicense(value) {
    var map = {
      'all':'All license types',
      'salesperson':'Salesperson',
      'broker-salesperson':'Broker-Salesperson',
      'broker':'Broker',
      'broker-group':'Broker / Broker-Salesperson',
      'timeshare':'Timeshare Agent'
    };
    return map[value] || value;
  }

  function labelPermit(value) {
    var map = {
      'property-management-permit':'Property Management Permit',
      'business-broker-permit':'Business Broker Permit'
    };
    return map[value] || value;
  }

  function labelDesignation(value) {
    var map = {
      'agency':'Agency',
      'contracts':'Contracts',
      'ethics':'Ethics',
      'law-legislation':'Law & Legislation',
      'risk-reduction':'Risk Reduction',
      'property-management':'Property Management',
      'broker-management':'Broker Management',
      'business-broker':'Business Broker',
      'commercial':'Commercial',
      'general':'General'
    };
    if (map[value]) return map[value];
    return String(value || '').replace(/-/g,' ').replace(/\b\w/g,function(ch){return ch.toUpperCase();});
  }

  function parseCatalogState() {
    var p = new URLSearchParams(window.location.search);
    var permits = String(p.get('permit') || '').split(',').filter(Boolean);
    return {
      state:'nevada',
      license:p.get('license') || 'all',
      permits:permits,
      delivery:String(p.get('delivery') || '').split(',').filter(Boolean),
      productType:p.get('product_type') || 'all',
      designation:p.get('designation') || 'all'
    };
  }

  function writeCatalogUrl(state, replace) {
    var url = new URL(window.location.href);
    url.searchParams.set('state','nevada');
    ['license','permit','delivery','product_type','designation'].forEach(function(k){url.searchParams.delete(k);});
    if (state.license && state.license !== 'all') url.searchParams.set('license',state.license);
    if (state.permits.length) url.searchParams.set('permit',state.permits.join(','));
    if (state.delivery.length) url.searchParams.set('delivery',state.delivery.join(','));
    if (state.productType && state.productType !== 'all') url.searchParams.set('product_type',state.productType);
    if (state.designation && state.designation !== 'all') url.searchParams.set('designation',state.designation);
    if (replace) history.replaceState({cbmNewUx:true},'',url.pathname+url.search);
    else history.pushState({cbmNewUx:true},'',url.pathname+url.search);
  }

  function commonCore(card) {
    var d = splitValues(card,'data-designation-values',designationKey);
    return d.some(function(v){return ['agency','contracts','ethics','law-legislation','risk-reduction','general','commercial'].indexOf(v)!==-1;});
  }

  function cardMatches(card, state) {
    var elig = splitValues(card,'data-license-values',licenseKey);
    var designations = splitValues(card,'data-designation-values',designationKey);
    var delivery = normalize(card.getAttribute('data-delivery-method') || '');
    var isPackage = card.getAttribute('data-is-package') === 'true';

    var baseMatch = true;
    if (state.license && state.license !== 'all') {
      if (state.license === 'broker-group') baseMatch = elig.indexOf('broker') !== -1 || elig.indexOf('broker-salesperson') !== -1;
      else baseMatch = elig.indexOf(state.license) !== -1;
    }

    var audienceMatch = baseMatch;
    if (state.permits.length) {
      var anyPermit = state.permits.some(function(p){return elig.indexOf(p)!==-1;});
      audienceMatch = anyPermit || (baseMatch && commonCore(card));
    }

    var deliveryMatch = true;
    if (state.delivery.length) {
      deliveryMatch = state.delivery.some(function(method) {
        if (method === 'live') return delivery.indexOf('zoom') !== -1 || delivery.indexOf('live') !== -1;
        if (method === 'online') return delivery.indexOf('online') !== -1 || delivery.indexOf('internet') !== -1 || delivery.indexOf('24') !== -1;
        if (method === 'in-person') return delivery.indexOf('person') !== -1 || delivery.indexOf('classroom') !== -1;
        return true;
      });
    }

    var productTypeMatch = state.productType === 'all' ||
      (state.productType === 'packages' && isPackage) ||
      (state.productType === 'individual' && !isPackage);

    var designationMatch = state.designation === 'all' || designations.indexOf(state.designation) !== -1 ||
      (state.designation === 'general' && card.getAttribute('data-general-ce-eligible') === 'true');

    return audienceMatch && deliveryMatch && productTypeMatch && designationMatch;
  }

  function headingFor(state) {
    if (state.license === 'salesperson') return 'Nevada Salesperson Continuing Education';
    if (state.license === 'broker') return 'Nevada Broker Continuing Education';
    if (state.license === 'broker-salesperson') return 'Nevada Broker-Salesperson Continuing Education';
    if (state.license === 'broker-group') return 'Nevada Broker & Broker-Salesperson Continuing Education';
    if (state.license === 'timeshare') return 'Nevada Timeshare Continuing Education';
    return 'Nevada Real Estate Continuing Education';
  }

  function profileKeys(state) {
    var keys = [];
    if (state.license === 'salesperson') keys.push('salesperson');
    if (state.license === 'broker' || state.license === 'broker-salesperson' || state.license === 'broker-group') keys.push('broker');
    if (state.license === 'timeshare') keys.push('timeshare');
    state.permits.forEach(function(p) {
      if (p === 'property-management-permit') keys.push('property-management');
      if (p === 'business-broker-permit') keys.push('business-broker');
    });
    return keys;
  }

  function updateGuide(state, context) {
    var guide = document.querySelector('[data-cbm-newux-renewal-guide]');
    if (!guide) return;
    var guideLicense = guide.querySelector('[data-cbm-guide-license]');
    if (guideLicense) guideLicense.value = state.license;
    var keys = profileKeys(state);
    var profiles = guide.querySelectorAll('[data-cbm-renewal-profile]');
    var shownProfiles=0;
    profiles.forEach(function(profile) {
      var show=keys.indexOf(profile.getAttribute('data-cbm-renewal-profile')) !== -1;
      profile.hidden=!show;
      if(show) shownProfiles++;
    });
    var empty = guide.querySelector('[data-cbm-renewal-empty]');
    if (empty) {
      empty.hidden = shownProfiles > 0;
      if (!keys.length) {
        empty.innerHTML='<div class="cbm-newux-renewal-profile__head"><div><h3>Choose your license</h3><div class="cbm-newux-renewal-profile__copy">Use the license selector here to display your renewal guide and matching courses. Permit guidance will appear when selected.</div></div></div>';
      } else if (!shownProfiles) {
        empty.innerHTML='<div class="cbm-newux-renewal-profile__head"><div><h3>Renewal guidance needs review</h3><div class="cbm-newux-renewal-profile__copy">CE by Matthew does not currently have a complete published renewal profile for this selection. The catalog remains available, but no regulatory requirement is being guessed here.</div></div></div>';
      }
    }
    var preview = context ? context.querySelector('[data-cbm-newux-guide-preview-copy]') : null;
    if (preview) {
      var offerLabel = state.productType === 'packages'
        ? 'These packages'
        : state.productType === 'individual'
          ? 'These individual courses'
          : 'These continuing education options';
      var audienceMap = {
        'salesperson':'Nevada Salespersons',
        'broker-salesperson':'Nevada Broker-Salespersons',
        'broker':'Nevada Brokers',
        'broker-group':'Nevada Brokers and Broker-Salespersons',
        'timeshare':'Nevada Timeshare Agents'
      };
      var audience = audienceMap[state.license] || 'Nevada real estate professionals';

      if (!keys.length) {
        preview.innerHTML = escapeHtml(offerLabel + ' are for ' + audience + ' completing continuing education for license renewal. ') +
          '<strong>Select your license type</strong> to see the matching renewal requirement summary.';
      } else {
        var selected = guide.querySelector('[data-cbm-renewal-profile="' + keys[0] + '"]');
        if (!selected) {
          preview.textContent = offerLabel + ' are for ' + audience + ' completing continuing education for license renewal. A complete published renewal profile is not available for this selection, so no requirement is being inferred.';
        } else {
          var facts=[];
          var total=selected.getAttribute('data-cbm-total-hours'), totalLabel=selected.getAttribute('data-cbm-total-label');
          var live=selected.getAttribute('data-cbm-live-hours'), liveLabelText=selected.getAttribute('data-cbm-live-label');
          var cycle=selected.getAttribute('data-cbm-cycle'), cycleLabel=selected.getAttribute('data-cbm-cycle-label');
          if(total)facts.push('<strong>'+escapeHtml(total+' '+(totalLabel||'total hours'))+'</strong>');
          if(live)facts.push('<strong>'+escapeHtml(live+' '+(liveLabelText||'live hours'))+'</strong>');
          if(cycle)facts.push('<strong>'+escapeHtml(cycle+' '+(cycleLabel||'renewal cycle'))+'</strong>');
          var requirementCopy = facts.length
            ? ' The documented renewal profile shows ' + facts.join(' <span aria-hidden="true">·</span> ') + '.'
            : ' Review the detailed renewal guide below for the current requirement breakdown.';
          var permitCopy = keys.length > 1 ? ' <strong>Selected permit guidance</strong> is included in the full renewal guide.' : '';
          preview.innerHTML = escapeHtml(offerLabel + ' are designed for ' + audience + ' completing continuing education for license renewal.') + requirementCopy + permitCopy;
        }
      }
    }
  }

  function escapeHtml(v) {
    return String(v || '').replace(/[&<>"']/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }

  function buildFilterRail(catalog, state, apply) {
    var cards = Array.prototype.slice.call(catalog.querySelectorAll('[data-product-card]'));
    var designationSet = {};
    var inPerson = false;
    cards.forEach(function(card) {
      splitValues(card,'data-designation-values',designationKey).forEach(function(v){designationSet[v]=true;});
      var delivery = normalize(card.getAttribute('data-delivery-method') || '');
      if (delivery.indexOf('person') !== -1 || delivery.indexOf('classroom') !== -1) inPerson = true;
    });
    var order = ['agency','contracts','ethics','law-legislation','risk-reduction','property-management','commercial','broker-management','business-broker','general'];
    var designationKeys = Object.keys(designationSet).sort(function(a,b){
      var ai=order.indexOf(a), bi=order.indexOf(b);
      if(ai===-1) ai=999; if(bi===-1) bi=999;
      return ai-bi || a.localeCompare(b);
    });

    var aside = document.createElement('aside');
    aside.className = 'cbm-newux-catalog__rail';
    aside.setAttribute('data-cbm-newux-filter-rail','');
    aside.innerHTML =
      '<div class="cbm-newux-catalog__rail-head"><h3 class="cbm-newux-catalog__rail-title">Filter courses</h3><button type="button" class="cbm-newux-catalog__clear" data-cbm-newux-clear>Reset</button></div>' +
      '<div class="cbm-newux-filter"><span class="cbm-newux-filter__label">State</span><div class="cbm-newux-filter__fixed">Nevada</div></div>' +
      '<fieldset class="cbm-newux-filter"><legend class="cbm-newux-filter__label">License Type</legend><div class="cbm-newux-filter__options">' +
        [['all','All'],['salesperson','Salesperson'],['broker-salesperson','Broker-Salesperson'],['broker','Broker'],['timeshare','Timeshare Agent']].map(function(opt){
          return '<label class="cbm-newux-filter__choice"><input type="radio" name="cbm-newux-license" value="'+opt[0]+'"> <span>'+opt[1]+'</span></label>';
        }).join('') +
      '</div></fieldset>' +
      '<fieldset class="cbm-newux-filter"><legend class="cbm-newux-filter__label">Delivery Method</legend><div class="cbm-newux-filter__options">' +
        '<label class="cbm-newux-filter__choice"><input type="checkbox" data-cbm-newux-delivery value="live"> <span>Live Zoom</span></label>' +
        '<label class="cbm-newux-filter__choice"><input type="checkbox" data-cbm-newux-delivery value="online"> <span>Online 24/7</span></label>' +
        (inPerson ? '<label class="cbm-newux-filter__choice"><input type="checkbox" data-cbm-newux-delivery value="in-person"> <span>In Person</span></label>' : '') +
      '</div></fieldset>' +
      '<fieldset class="cbm-newux-filter"><legend class="cbm-newux-filter__label">Product Type</legend><div class="cbm-newux-filter__options">' +
        '<label class="cbm-newux-filter__choice"><input type="radio" name="cbm-newux-product-type" value="packages"> <span>Packages</span></label>' +
        '<label class="cbm-newux-filter__choice"><input type="radio" name="cbm-newux-product-type" value="individual"> <span>Individual Courses</span></label>' +
      '</div></fieldset>' +
      '<fieldset class="cbm-newux-filter"><legend class="cbm-newux-filter__label">Permits</legend><div class="cbm-newux-filter__options">' +
        '<label class="cbm-newux-filter__choice"><input type="checkbox" data-cbm-newux-permit value="property-management-permit"> <span>Property Management</span></label>' +
        '<label class="cbm-newux-filter__choice"><input type="checkbox" data-cbm-newux-permit value="business-broker-permit"> <span>Business Broker</span></label>' +
      '</div></fieldset>' +
      '<div class="cbm-newux-filter"><label class="cbm-newux-filter__label" for="CbmNewUxDesignation">Designations</label><select id="CbmNewUxDesignation" data-cbm-newux-designation><option value="all">All designations</option>' +
        designationKeys.map(function(key){return '<option value="'+key+'">'+escapeHtml(labelDesignation(key))+'</option>';}).join('') +
      '</select></div>';

    function syncControls() {
      var radio = aside.querySelector('input[name="cbm-newux-license"][value="'+state.license+'"]');
      if (!radio && state.license === 'broker-group') radio = aside.querySelector('input[name="cbm-newux-license"][value="all"]');
      if (radio) radio.checked = true;
      aside.querySelectorAll('[data-cbm-newux-permit]').forEach(function(i){ i.checked = state.permits.indexOf(i.value)!==-1; });
      aside.querySelectorAll('[data-cbm-newux-delivery]').forEach(function(i){ i.checked = state.delivery.indexOf(i.value)!==-1; });
      aside.querySelectorAll('input[name="cbm-newux-product-type"]').forEach(function(i){ i.checked = state.productType === i.value; });
      var select = aside.querySelector('[data-cbm-newux-designation]');
      if (select && Array.prototype.some.call(select.options,function(o){return o.value===state.designation;})) select.value=state.designation;
    }
    syncControls();

    aside.addEventListener('change', function(e) {
      var previousDelivery = state.delivery.slice();
      if (e.target.name === 'cbm-newux-license') state.license = e.target.value;
      state.permits = Array.prototype.filter.call(aside.querySelectorAll('[data-cbm-newux-permit]'),function(i){return i.checked;}).map(function(i){return i.value;});
      state.delivery = Array.prototype.filter.call(aside.querySelectorAll('[data-cbm-newux-delivery]'),function(i){return i.checked;}).map(function(i){return i.value;});
      var productTypeChoice = aside.querySelector('input[name="cbm-newux-product-type"]:checked');
      state.productType = productTypeChoice ? productTypeChoice.value : 'all';
      var s = aside.querySelector('[data-cbm-newux-designation]');
      state.designation = s ? s.value : 'all';

      var scrollToDelivery = '';
      if (
        e.target.matches('[data-cbm-newux-delivery]') &&
        e.target.checked &&
        state.productType === 'individual' &&
        previousDelivery.length > 0 &&
        state.delivery.length > previousDelivery.length
      ) {
        scrollToDelivery = e.target.value;
      }

      apply(true, {scrollToDelivery:scrollToDelivery});
    });
    aside.querySelector('[data-cbm-newux-clear]').addEventListener('click', function() {
      state.license='all'; state.permits=[]; state.delivery=[]; state.productType='all'; state.designation='all';
      syncControls();
      apply(true);
    });
    return aside;
  }

  function initCatalog() {
    var catalog = document.querySelector('[data-cbm-course-catalog]');
    if (!catalog || catalog.dataset.cbmNewUxReady === 'true') return;
    var grid = catalog.querySelector('[data-product-grid]');
    var emptyState = catalog.querySelector('[data-no-results]');
    if (!grid) return;
    catalog.dataset.cbmNewUxReady = 'true';
    catalog.classList.add('cbm-newux-catalog');

    var catalogLoadingFailSafe = window.setTimeout(function() {
      catalog.classList.remove('cbm-newux-catalog--loading');
      catalog.setAttribute('aria-busy', 'false');
    }, 6000);

    var state = parseCatalogState();
    var shell = document.createElement('div');
    shell.className = 'cbm-newux-catalog__shell';

    var main = document.createElement('div');
    main.className = 'cbm-newux-catalog__main';
    var context = document.createElement('div');
    context.className = 'cbm-newux-catalog__context';
    context.innerHTML =
      '<div class="cbm-newux-catalog__crumbs" data-cbm-newux-crumbs></div>' +
      '<h2 class="cbm-newux-catalog__heading" data-cbm-newux-heading></h2>' +
      '<div class="cbm-newux-catalog__guide-preview">' +
        '<div class="cbm-newux-catalog__guide-copy" data-cbm-newux-guide-preview-copy></div>' +
        '<a class="cbm-newux-catalog__guide-link" href="#cbm-newux-renewal-guide" data-cbm-newux-guide-link>View Renewal Guide</a>' +
      '</div>';

    var guideLink = context.querySelector('[data-cbm-newux-guide-link]');
    if (guideLink) {
      var guideNudgeTimer = null;
      var guideNudgeDone = false;
      var reduceGuideMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function scheduleGuideNudge() {
        if (guideNudgeDone || reduceGuideMotion) return;
        if (guideNudgeTimer) window.clearTimeout(guideNudgeTimer);
        guideNudgeTimer = window.setTimeout(function() {
          var rect = guideLink.getBoundingClientRect();
          var visible = rect.bottom > 0 && rect.top < window.innerHeight;
          if (!visible) {
            scheduleGuideNudge();
            return;
          }
          guideNudgeDone = true;
          guideLink.classList.add('is-idle-nudge');
        }, 5000);
      }

      guideLink.addEventListener('animationend', function() {
        guideLink.classList.remove('is-idle-nudge');
      });

      guideLink.addEventListener('click', function(event) {
        guideNudgeDone = true;
        if (guideNudgeTimer) window.clearTimeout(guideNudgeTimer);
        var guide = document.querySelector('[data-cbm-newux-renewal-guide]');
        if (!guide) return;
        event.preventDefault();
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        guide.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
      });

      ['pointerdown','keydown','scroll','touchstart'].forEach(function(eventName) {
        window.addEventListener(eventName, scheduleGuideNudge, eventName === 'scroll' || eventName === 'touchstart' ? {passive:true} : false);
      });
      scheduleGuideNudge();
    }
    var resultRow = document.createElement('div');
    resultRow.className = 'cbm-newux-catalog__result-row';
    resultRow.innerHTML =
      '<button type="button" class="cbm-newux-mobile-filter" data-cbm-newux-mobile-filter>☰ Filters</button>' +
      '<label class="cbm-newux-mobile-license"><span class="visually-hidden">License type</span><select data-cbm-newux-mobile-license aria-label="License type">' +
        '<option value="all">All license types</option>' +
        '<option value="salesperson">Salesperson</option>' +
        '<option value="broker-salesperson">Broker-Salesperson</option>' +
        '<option value="broker">Broker</option>' +
        '<option value="timeshare">Timeshare Agent</option>' +
      '</select></label>' +
      '<span class="cbm-newux-catalog__result-count" data-cbm-newux-result-count></span>';
    main.appendChild(context);
    main.appendChild(resultRow);

    var productTypeToggle = document.createElement('div');
    productTypeToggle.className = 'cbm-newux-catalog__type-toggle';
    productTypeToggle.setAttribute('data-cbm-newux-product-type-toggle','');
    productTypeToggle.setAttribute('role','group');
    productTypeToggle.setAttribute('aria-label','Product type');
    productTypeToggle.innerHTML =
      '<button type="button" class="cbm-newux-catalog__type-toggle-button" data-cbm-newux-product-type-toggle-value="packages" aria-pressed="false">Packages</button>' +
      '<button type="button" class="cbm-newux-catalog__type-toggle-button" data-cbm-newux-product-type-toggle-value="individual" aria-pressed="false">Individual Courses</button>';

    var catalogTopbar = document.createElement('div');
    catalogTopbar.className = 'cbm-newux-catalog__type-bar';
    catalogTopbar.setAttribute('data-cbm-newux-type-bar','');
    catalogTopbar.appendChild(productTypeToggle);
    var resultCount = resultRow.querySelector('[data-cbm-newux-result-count]');
    if (resultCount) catalogTopbar.appendChild(resultCount);
    grid.insertBefore(catalogTopbar, grid.firstChild);

    var permitCourseGroup = document.createElement('div');
    permitCourseGroup.className = 'cbm-newux-catalog__course-group cbm-newux-catalog__course-group--permit';
    permitCourseGroup.setAttribute('data-cbm-newux-permit-course-group','');
    permitCourseGroup.hidden = true;
    permitCourseGroup.innerHTML = '<strong data-cbm-newux-permit-group-title></strong><span data-cbm-newux-permit-group-copy></span>';
    permitCourseGroup.style.order = '5';

    var otherCourseGroup = document.createElement('div');
    otherCourseGroup.className = 'cbm-newux-catalog__course-group cbm-newux-catalog__course-group--other';
    otherCourseGroup.setAttribute('data-cbm-newux-other-course-group','');
    otherCourseGroup.hidden = true;
    otherCourseGroup.innerHTML = '<strong>Other courses for your renewal</strong><span>Additional approved CE that may apply to your base license renewal.</span>';
    otherCourseGroup.style.order = '20';

    var liveCourseGroup = document.createElement('div');
    liveCourseGroup.className = 'cbm-newux-catalog__course-group cbm-newux-catalog__course-group--delivery';
    liveCourseGroup.setAttribute('data-cbm-newux-live-course-group','');
    liveCourseGroup.hidden = true;
    liveCourseGroup.innerHTML = '<strong>Live Zoom courses</strong>';
    liveCourseGroup.style.order = '5';

    var onlineCourseGroup = document.createElement('div');
    onlineCourseGroup.className = 'cbm-newux-catalog__course-group cbm-newux-catalog__course-group--delivery';
    onlineCourseGroup.setAttribute('data-cbm-newux-online-course-group','');
    onlineCourseGroup.hidden = true;
    onlineCourseGroup.innerHTML = '<strong>Online 24/7 courses</strong>';
    onlineCourseGroup.style.order = '20';

    grid.insertBefore(onlineCourseGroup, catalogTopbar.nextSibling);
    grid.insertBefore(liveCourseGroup, onlineCourseGroup);
    grid.insertBefore(otherCourseGroup, liveCourseGroup);
    grid.insertBefore(permitCourseGroup, otherCourseGroup);

    var backdrop = document.createElement('button');
    backdrop.type='button';
    backdrop.className='cbm-newux-filter-sheet__backdrop';
    backdrop.setAttribute('aria-label','Close filters');
    backdrop.hidden=true;

    var rail;

    function syncProductTypeControls() {
      productTypeToggle.querySelectorAll('[data-cbm-newux-product-type-toggle-value]').forEach(function(button){
        var active = state.productType === button.getAttribute('data-cbm-newux-product-type-toggle-value');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (rail) {
        rail.querySelectorAll('input[name="cbm-newux-product-type"]').forEach(function(input){
          input.checked = state.productType === input.value;
        });
      }
    }

    function syncLicenseControls() {
      if (rail) {
        var licenseRadio = rail.querySelector('input[name="cbm-newux-license"][value="'+state.license+'"]');
        if (!licenseRadio && state.license === 'broker-group') licenseRadio = rail.querySelector('input[name="cbm-newux-license"][value="all"]');
        if (licenseRadio) licenseRadio.checked = true;
      }
      var mobileLicense = main.querySelector('[data-cbm-newux-mobile-license]');
      if (mobileLicense) {
        var mobileValue = state.license === 'broker-group' ? 'all' : state.license;
        if (Array.prototype.some.call(mobileLicense.options,function(option){return option.value===mobileValue;})) mobileLicense.value=mobileValue;
      }
    }

    function apply(updateUrl, options) {
      options = options || {};
      var visible=0;
      var permitGrouping = state.productType === 'individual' && state.permits.length > 0;
      var deliveryGrouping = state.productType === 'individual' &&
        state.delivery.length === 2 &&
        state.delivery.indexOf('live') !== -1 &&
        state.delivery.indexOf('online') !== -1;
      var permitSpecificVisible = 0;
      var otherVisible = 0;
      var liveVisible = 0;
      var onlineVisible = 0;
      var permitDesignationMap = {
        'property-management-permit':'property-management',
        'business-broker-permit':'business-broker'
      };

      catalog.querySelectorAll('[data-product-card]').forEach(function(card){
        var show=cardMatches(card,state);
        card.hidden=!show;
        card.style.removeProperty('order');

        if(show) {
          visible++;
          if (card.getAttribute('data-is-package') !== 'true') {
            var eligibility = splitValues(card,'data-license-values',licenseKey);
            var designations = splitValues(card,'data-designation-values',designationKey);
            var deliveryText = normalize(card.getAttribute('data-delivery-method') || '');
            var isLiveCourse = deliveryText.indexOf('zoom') !== -1 || deliveryText.indexOf('live') !== -1;
            var isOnlineCourse = deliveryText.indexOf('online') !== -1 || deliveryText.indexOf('internet') !== -1 || deliveryText.indexOf('24') !== -1;
            var permitSpecific = state.permits.some(function(permit) {
              var designation = permitDesignationMap[permit];
              return eligibility.indexOf(permit) !== -1 || (designation && designations.indexOf(designation) !== -1);
            });

            if (deliveryGrouping) {
              if (isLiveCourse) {
                card.style.order = permitSpecific ? '10' : '12';
                liveVisible++;
              } else if (isOnlineCourse) {
                card.style.order = permitSpecific ? '30' : '32';
                onlineVisible++;
              } else {
                card.style.order = '40';
              }

              if (permitSpecific) permitSpecificVisible++;
              else otherVisible++;
            } else if (permitGrouping) {
              card.style.order = permitSpecific ? '10' : '30';
              if (permitSpecific) permitSpecificVisible++;
              else otherVisible++;
            }
          }
        }
      });

      var heading=context.querySelector('[data-cbm-newux-heading]');
      if(heading) heading.textContent=headingFor(state);
      var crumbs=context.querySelector('[data-cbm-newux-crumbs]');
      var chipValues=['Nevada'];
      if(state.license!=='all') chipValues.push(labelLicense(state.license));
      state.permits.forEach(function(p){chipValues.push(labelPermit(p));});
      state.delivery.forEach(function(d){chipValues.push(d==='live'?'Live Zoom':d==='online'?'Online 24/7':'In Person');});
      if(state.productType==='packages') chipValues.push('Packages');
      if(state.productType==='individual') chipValues.push('Individual Courses');
      if(state.designation!=='all') chipValues.push(labelDesignation(state.designation));
      crumbs.innerHTML=chipValues.map(function(v){return '<span class="cbm-newux-catalog__chip">'+escapeHtml(v)+'</span>';}).join('');

      var count=main.querySelector('[data-cbm-newux-result-count]');
      if(count) count.textContent=visible+(visible===1?' course option':' course options');

      if (emptyState) {
        emptyState.hidden = visible > 0;
        if (visible === 0) {
          emptyState.textContent = state.productType === 'packages'
            ? 'There are no packages available for this selection. Try Individual Courses or adjust your filters.'
            : 'There are no items available for this selection. Try changing one or more filters.';
        }
      }

      if (permitCourseGroup && otherCourseGroup) {
        var permitTitle = permitCourseGroup.querySelector('[data-cbm-newux-permit-group-title]');
        var permitCopy = permitCourseGroup.querySelector('[data-cbm-newux-permit-group-copy]');

        if (permitGrouping && state.permits.length === 1) {
          if (state.permits[0] === 'property-management-permit') {
            if (permitTitle) permitTitle.textContent = 'Property Management courses';
            if (permitCopy) permitCopy.textContent = 'Courses that satisfy your Property Management permit requirement.';
          } else if (state.permits[0] === 'business-broker-permit') {
            if (permitTitle) permitTitle.textContent = 'Business Broker courses';
            if (permitCopy) permitCopy.textContent = 'Courses that satisfy your Business Broker permit requirement.';
          }
        } else if (permitGrouping) {
          if (permitTitle) permitTitle.textContent = 'Permit courses';
          if (permitCopy) permitCopy.textContent = 'Courses that satisfy one or more of your selected permit requirements.';
        }

        permitCourseGroup.hidden = deliveryGrouping || !permitGrouping || permitSpecificVisible === 0;
        otherCourseGroup.hidden = deliveryGrouping || !permitGrouping || otherVisible === 0;
      }

      if (liveCourseGroup && onlineCourseGroup) {
        liveCourseGroup.hidden = !deliveryGrouping || liveVisible === 0;
        onlineCourseGroup.hidden = !deliveryGrouping || onlineVisible === 0;
      }

      syncProductTypeControls();
      syncLicenseControls();
      updateGuide(state,context);
      if(updateUrl) writeCatalogUrl(state,false);

      if (options.scrollToDelivery && deliveryGrouping) {
        var deliveryTarget = options.scrollToDelivery === 'online' ? onlineCourseGroup :
          options.scrollToDelivery === 'live' ? liveCourseGroup : null;
        if (deliveryTarget && !deliveryTarget.hidden) {
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.setTimeout(function() {
            deliveryTarget.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
          }, window.innerWidth < 990 ? 140 : 20);
        }
      }
    }

    rail=buildFilterRail(catalog,state,apply);

    var guideControls = document.querySelector('[data-cbm-guide-controls]');
    if (guideControls) {
      var guideLicense = guideControls.querySelector('[data-cbm-guide-license]');
      var licenseRadios = Array.from(rail.querySelectorAll('input[name="cbm-newux-license"]'));
      licenseRadios.forEach(function(radio) {
        var option = document.createElement('option');
        option.value = radio.value;
        option.textContent = radio.value === 'all' ? 'Choose your license' : radio.parentElement.textContent.trim();
        guideLicense.appendChild(option);
      });
      if (state.license === 'broker-group') {
        var groupOption = document.createElement('option');
        groupOption.value = 'broker-group';
        groupOption.textContent = 'Broker / Broker-Salesperson';
        groupOption.hidden = true;
        guideLicense.appendChild(groupOption);
      }
      guideLicense.addEventListener('change', function() {
        var radio = licenseRadios.find(function(input) { return input.value === guideLicense.value; });
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
      });
      guideControls.querySelector('[data-cbm-guide-browse]').addEventListener('click', function() {
        var target = main.querySelector('[data-cbm-newux-heading]');
        if (!target) return;
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll:true});
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
      });
      guideControls.hidden = false;
    }

    productTypeToggle.addEventListener('click',function(event){
      var button=event.target.closest('[data-cbm-newux-product-type-toggle-value]');
      if(!button||!productTypeToggle.contains(button))return;
      state.productType=button.getAttribute('data-cbm-newux-product-type-toggle-value')||'all';
      apply(true);
    });

    var gridParent=grid.parentNode;
    if(!gridParent) return;
    gridParent.insertBefore(shell,grid);
    shell.appendChild(rail);
    shell.appendChild(main);
    if (emptyState) grid.appendChild(emptyState);
    main.appendChild(grid);
    catalog.insertBefore(backdrop,shell);

    var mobileButton=main.querySelector('[data-cbm-newux-mobile-filter]');
    var mobileLicense=main.querySelector('[data-cbm-newux-mobile-license]');
    function closeRail(){rail.classList.remove('is-open');backdrop.hidden=true;document.body.classList.remove('cbm-newux-modal-open');}
    mobileButton.addEventListener('click',function(){rail.classList.add('is-open');backdrop.hidden=false;document.body.classList.add('cbm-newux-modal-open');});
    if (mobileLicense) {
      mobileLicense.addEventListener('change',function(){
        state.license=mobileLicense.value||'all';
        apply(true);
      });
    }
    backdrop.addEventListener('click',closeRail);
    rail.addEventListener('change',function(){ if(window.innerWidth<990) closeRail(); });
    window.addEventListener('popstate',function(){ state=parseCatalogState(); window.location.reload(); });
    apply(true);
    initPurchaseFlow(catalog);
    window.clearTimeout(catalogLoadingFailSafe);
    catalog.classList.remove('cbm-newux-catalog--loading');
    catalog.setAttribute('aria-busy', 'false');
  }

  function ensurePurchaseModal() {
    var modal=document.querySelector('[data-cbm-newux-purchase-modal]');
    if(modal) return modal;
    modal=document.createElement('div');
    modal.className='cbm-newux-modal';
    modal.setAttribute('data-cbm-newux-purchase-modal','');
    modal.hidden=true;
    modal.innerHTML =
      '<button type="button" class="cbm-newux-modal__backdrop" data-cbm-newux-close aria-label="Close enrollment"></button>' +
      '<div class="cbm-newux-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="CbmNewUxModalTitle">' +
        '<div class="cbm-newux-modal__header"><div><p class="cbm-newux-modal__eyebrow">CE BY MATTHEW</p><h2 class="cbm-newux-modal__title" id="CbmNewUxModalTitle">Select your class date</h2><p class="cbm-newux-modal__reschedule-note" data-cbm-newux-reschedule-note>You can reschedule anytime using the link in your confirmation email.</p></div><button type="button" class="cbm-newux-modal__close" data-cbm-newux-close aria-label="Close">&times;</button></div>' +
        '<div class="cbm-newux-modal__progress"><div class="cbm-newux-modal__step" data-step-indicator="dates">Choose Dates</div><div class="cbm-newux-modal__step" data-step-indicator="review">Review</div><div class="cbm-newux-modal__step" data-step-indicator="student">Student Information</div><div class="cbm-newux-modal__step" data-step-indicator="cart">Cart</div></div>' +
        '<div class="cbm-newux-modal__body" data-cbm-newux-modal-body></div>' +
        '<div class="cbm-newux-modal__footer"><div class="cbm-newux-modal__footer-left"><button type="button" class="cbm-newux-modal__cancel" data-cbm-newux-cancel>Cancel</button><button type="button" class="cbm-newux-modal__button cbm-newux-modal__button--save-close" data-cbm-newux-save-close>Save &amp; Close</button></div><div class="cbm-newux-modal__footer-right"><button type="button" class="cbm-newux-modal__button" data-cbm-newux-back>Back</button><button type="button" class="cbm-newux-modal__button cbm-newux-modal__button--primary" data-cbm-newux-next>Continue</button></div></div>' +
      '</div>';
    document.body.appendChild(modal);
    return modal;
  }

  function initPurchaseFlow(catalog) {
    var modal=ensurePurchaseModal();
    var body=modal.querySelector('[data-cbm-newux-modal-body]');
    var back=modal.querySelector('[data-cbm-newux-back]');
    var next=modal.querySelector('[data-cbm-newux-next]');
    var cancel=modal.querySelector('[data-cbm-newux-cancel]');
    var saveClose=modal.querySelector('[data-cbm-newux-save-close]');
    var progress=modal.querySelector('.cbm-newux-modal__progress');
    var flow=null;

    if(cancel)cancel.hidden=false;
    if(saveClose)saveClose.hidden=false;
    if(progress)progress.style.display='';

    function serializeDraftSelection(selection) {
      if(!selection||!selection.event)return null;
      return {
        courseId:selection.courseId||'',
        sessionId:String(selection.event.session_id||'')
      };
    }

    function serializeStudentDraft(student) {
      if(!student)return null;
      return {
        type:student.type||'Purchaser',
        state:student.state||'Nevada',
        licenseType:student.licenseType||'Salesperson',
        licenseNumber:String(student.licenseNumber||''),
        suffix:String(student.suffix||''),
        first:String(student.first||''),
        last:String(student.last||''),
        email:String(student.email||'')
      };
    }

    function saveCurrentDraft() {
      if(!flow||!flow.variantId)return false;
      var draft={
        version:PURCHASE_DRAFT_VERSION,
        variantId:String(flow.variantId),
        mode:flow.mode,
        codes:(flow.codes||[]).slice(),
        title:flow.title||'',
        delivery:flow.delivery||'',
        selections:(flow.selections||[]).map(serializeDraftSelection),
        monthByCode:Object.assign({},flow.monthByCode||{}),
        editReviewIndex:typeof flow.editReviewIndex==='number'?flow.editReviewIndex:null,
        editDraftSelection:serializeDraftSelection(flow.editDraftSelection),
        codeIndex:Number(flow.codeIndex)||0,
        student:serializeStudentDraft(flow.student),
        step:flow.step||'dates',
        updatedAt:Date.now()
      };
      writePurchaseDraft(flow.variantId,draft);
      notifyPurchaseDraftState(flow.variantId);
      return true;
    }

    function hydrateDraft(baseFlow,draft) {
      if(!draft||draft.version!==PURCHASE_DRAFT_VERSION)return baseFlow;
      var sameVariant=String(draft.variantId||'')===String(baseFlow.variantId||'');
      var sameMode=String(draft.mode||'')===String(baseFlow.mode||'');
      var draftCodes=Array.isArray(draft.codes)?draft.codes:[];
      var sameCodes=draftCodes.length===baseFlow.codes.length&&draftCodes.every(function(code,index){
        return String(code)===String(baseFlow.codes[index]);
      });
      if(!sameVariant||!sameMode||!sameCodes){
        clearPurchaseDraft(baseFlow.variantId);
        notifyPurchaseDraftState(baseFlow.variantId);
        return baseFlow;
      }

      baseFlow.monthByCode=draft.monthByCode&&typeof draft.monthByCode==='object'?Object.assign({},draft.monthByCode):{};
      baseFlow.student=draft.student&&typeof draft.student==='object'?Object.assign({},draft.student):null;
      baseFlow.codeIndex=Math.max(0,Math.min(baseFlow.codes.length-1,Number(draft.codeIndex)||0));
      baseFlow.step=['dates','review','student'].indexOf(draft.step)!==-1?draft.step:(baseFlow.mode==='none'?'review':'dates');
      baseFlow.selections=new Array(baseFlow.codes.length).fill(null);
      var firstUnavailable=-1;

      if(baseFlow.mode!=='none'){
        (draft.selections||[]).forEach(function(saved,index){
          if(!saved||!saved.sessionId||index>=baseFlow.codes.length)return;
          var code=baseFlow.codes[index];
          var event=upcomingEvents(code).find(function(item){
            return String(item.session_id||'')===String(saved.sessionId);
          });
          if(event)baseFlow.selections[index]={courseId:code,event:event};
          else if(firstUnavailable<0)firstUnavailable=index;
        });

        if(typeof draft.editReviewIndex==='number'&&draft.editReviewIndex>=0&&draft.editReviewIndex<baseFlow.codes.length&&draft.editDraftSelection&&draft.editDraftSelection.sessionId){
          var editCode=baseFlow.codes[draft.editReviewIndex];
          var editEvent=upcomingEvents(editCode).find(function(item){
            return String(item.session_id||'')===String(draft.editDraftSelection.sessionId);
          });
          if(editEvent){
            baseFlow.editReviewIndex=draft.editReviewIndex;
            baseFlow.editDraftSelection={courseId:editCode,event:editEvent};
          }
        }

        if(firstUnavailable>=0){
          baseFlow.codeIndex=firstUnavailable;
          baseFlow.step='dates';
          baseFlow.editReviewIndex=null;
          baseFlow.editDraftSelection=null;
          baseFlow.resumeNotice='One of your saved class dates is no longer available. Please choose a new date.';
        } else if(baseFlow.step==='review'||baseFlow.step==='student'){
          var firstMissing=-1;
          for(var missingSelectionIndex=0;missingSelectionIndex<baseFlow.codes.length;missingSelectionIndex++){
            if(!baseFlow.selections[missingSelectionIndex]){firstMissing=missingSelectionIndex;break;}
          }
          if(firstMissing>=0){
            baseFlow.codeIndex=firstMissing;
            baseFlow.step='dates';
            baseFlow.editReviewIndex=null;
            baseFlow.editDraftSelection=null;
          }
        } else if(baseFlow.step==='dates'&&typeof baseFlow.editReviewIndex==='number'&&!baseFlow.editDraftSelection){
          baseFlow.editReviewIndex=null;
          baseFlow.step='review';
        }
      } else {
        baseFlow.step=baseFlow.step==='student'?'student':'review';
      }

      baseFlow.resumedFromDraft=true;
      return baseFlow;
    }

    function hideModal() {
      var returnFocus=flow&&flow.button;
      modal.hidden=true;
      document.body.classList.remove('cbm-newux-modal-open');
      flow=null;
      if(returnFocus&&typeof returnFocus.focus==='function')returnFocus.focus();
    }

    function saveAndClose() {
      if(flow&&flow.step!=='cart'&&!flow.itemAdded)saveCurrentDraft();
      hideModal();
    }

    function cancelFlow() {
      if(!flow){hideModal();return;}
      if(flow.step==='cart'||flow.itemAdded){hideModal();return;}
      var hasProgress=(flow.selections||[]).some(Boolean)||!!flow.student||flow.step!==(flow.mode==='none'?'review':'dates')||hasPurchaseDraft(flow.variantId);
      if(hasProgress&&!window.confirm('Discard your saved class selections and information?'))return;
      var variantId=flow.variantId;
      clearPurchaseDraft(variantId);
      notifyPurchaseDraftState(variantId);
      hideModal();
    }

    modal.querySelectorAll('[data-cbm-newux-close]').forEach(function(b){b.addEventListener('click',saveAndClose);});
    if(saveClose)saveClose.addEventListener('click',saveAndClose);
    if(cancel)cancel.addEventListener('click',cancelFlow);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)saveAndClose();});

    function setStep(step) {
      flow.step=step;
      var modalTitle=modal.querySelector('#CbmNewUxModalTitle');
      var rescheduleNote=modal.querySelector('[data-cbm-newux-reschedule-note]');
      if(modalTitle) {
        if(step==='dates') modalTitle.textContent='Select your class date';
        if(step==='review') modalTitle.textContent='Review your selections';
        if(step==='student') modalTitle.textContent='Student information';
        if(step==='cart') modalTitle.textContent='Your cart';
      }
      if(rescheduleNote) rescheduleNote.hidden=step!=='dates';
      if(progress)progress.classList.toggle('is-no-dates',flow.mode==='none');
      var order=['dates','review','student','cart'];
      order.forEach(function(s){
        var node=modal.querySelector('[data-step-indicator="'+s+'"]');
        if(!node)return;
        node.classList.toggle('is-active',s===step);
        node.classList.toggle('is-complete',order.indexOf(s)<order.indexOf(step));
        if(flow.mode==='none' && s==='dates') node.style.display='none'; else node.style.display='';
      });
      var editingReviewDate=step==='dates' && typeof flow.editReviewIndex==='number' && flow.editReviewIndex===flow.codeIndex;
      if(cancel)cancel.hidden=step==='cart';
      if(saveClose){
        saveClose.hidden=false;
        saveClose.textContent=step==='cart'?'Add more courses':'Save & Close';
      }
      back.textContent=editingReviewDate?'Back to Review':'Back';
      back.hidden=(step==='cart'||(step==='dates'&&!editingReviewDate)||(flow.mode==='none'&&step==='review'));
      render();
    }

    function renderDates() {
      var code=flow.codes[flow.codeIndex];
      var events=upcomingEvents(code);
      var months=[];
      var seenMonths={};

      events.forEach(function(event) {
        var monthInfo=pacificMonthParts(event.start);
        if(!seenMonths[monthInfo.key]) {
          seenMonths[monthInfo.key]=true;
          months.push(monthInfo);
        }
      });
      months.sort(function(a,b){return a.key.localeCompare(b.key);});

      flow.monthByCode=flow.monthByCode||{};
      var currentMonth=pacificMonthParts(new Date()).key;
      var selectedMonth=flow.monthByCode[code]||'';
      var editingReviewDate=typeof flow.editReviewIndex==='number' && flow.editReviewIndex===flow.codeIndex;
      var activeSelection=editingReviewDate && flow.editDraftSelection ? flow.editDraftSelection : flow.selections[flow.codeIndex];
      var selectedEvent=activeSelection&&activeSelection.event ? activeSelection.event : null;

      if(!selectedMonth || !seenMonths[selectedMonth]) {
        if(selectedEvent) {
          var selectedEventMonth=pacificMonthParts(selectedEvent.start).key;
          if(seenMonths[selectedEventMonth]) selectedMonth=selectedEventMonth;
        }
        if(!selectedMonth && seenMonths[currentMonth]) selectedMonth=currentMonth;
        if(!selectedMonth && months.length) {
          var futureMonth=months.find(function(month){return month.key>=currentMonth;});
          selectedMonth=(futureMonth||months[0]).key;
        }
        flow.monthByCode[code]=selectedMonth;
      }

      var visibleEvents=events.filter(function(event){
        return !selectedMonth || pacificMonthParts(event.start).key===selectedMonth;
      });
      var monthIndex=months.findIndex(function(month){return month.key===selectedMonth;});
      var monthOptions=months.map(function(month){
        return '<option value="'+escapeHtml(month.key)+'" '+(month.key===selectedMonth?'selected':'')+'>'+escapeHtml(month.label)+'</option>';
      }).join('');
      var monthNav=months.length
        ? '<div class="cbm-newux-month-nav">' +
            '<label class="cbm-newux-month-select"><span class="cbm-newux-sr-only">Choose month</span><select data-cbm-newux-month aria-label="Choose month">'+monthOptions+'</select></label>' +
            '<div class="cbm-newux-month-arrows" aria-label="Browse available months">' +
              '<button type="button" data-cbm-newux-month-prev aria-label="Previous available month" '+(monthIndex<=0?'disabled':'')+'>&laquo;</button>' +
              '<button type="button" data-cbm-newux-month-next aria-label="Next available month" '+(monthIndex<0||monthIndex>=months.length-1?'disabled':'')+'>&raquo;</button>' +
            '</div>' +
          '</div>'
        : '';

      var sessionMarkup=visibleEvents.length
        ? visibleEvents.map(function(event,index){
            var s=pacificParts(event.start), e=pacificParts(event.end);
            var checked=selectedEvent && selectedEvent.session_id===event.session_id;
            return '<label class="cbm-newux-session"><input type="radio" name="cbm-newux-session" value="'+index+'" '+(checked?'checked':'')+'><span><strong>'+escapeHtml(s.date)+'</strong><span>'+escapeHtml(s.time+' - '+e.time+' PT')+'</span></span></label>';
          }).join('')
        : '<div class="cbm-newux-month-empty">No available Zoom sessions are currently listed for this month.</div>';

      body.innerHTML='<div class="cbm-newux-modal__course-line"><strong class="cbm-newux-modal__course-title">'+escapeHtml(courseName(code))+' <span class="cbm-newux-modal__course-code">| '+escapeHtml(code)+'</span></strong><span>Class '+(catalogCourseIndices(flow.codes).indexOf(flow.codeIndex)+1)+' of '+flow.codes.length+'</span></div>' +
        '<p class="cbm-newux-modal__lead">Choose one available Zoom session. All scheduled classes are shown in Pacific Time.</p>' +
        monthNav +
        '<div class="cbm-newux-session-list">'+sessionMarkup+'</div><p class="cbm-newux-modal__status" data-cbm-newux-status></p>';

      var monthSelect=body.querySelector('[data-cbm-newux-month]');
      if(monthSelect) {
        monthSelect.addEventListener('change',function(){
          flow.monthByCode[code]=monthSelect.value;
          renderDates();
        });
      }
      var previousMonth=body.querySelector('[data-cbm-newux-month-prev]');
      if(previousMonth) {
        previousMonth.addEventListener('click',function(){
          if(monthIndex<=0) return;
          flow.monthByCode[code]=months[monthIndex-1].key;
          renderDates();
        });
      }
      var nextMonth=body.querySelector('[data-cbm-newux-month-next]');
      if(nextMonth) {
        nextMonth.addEventListener('click',function(){
          if(monthIndex<0||monthIndex>=months.length-1) return;
          flow.monthByCode[code]=months[monthIndex+1].key;
          renderDates();
        });
      }

      body.querySelectorAll('input[name="cbm-newux-session"]').forEach(function(input){
        input.addEventListener('change',function(){
          var selection={courseId:code,event:visibleEvents[Number(input.value)]};
          if(editingReviewDate) flow.editDraftSelection=selection;
          else flow.selections[flow.codeIndex]=selection;
          next.disabled=false;
        });
      });
      var hasLaterMissing=catalogMissingIndex(flow,flow.codeIndex)>=0;
      next.textContent=editingReviewDate?'Save Change':(hasLaterMissing?'Choose Next Class':'Review Selections');
      next.disabled=editingReviewDate?!flow.editDraftSelection:!flow.selections[flow.codeIndex];
      if(flow.resumeNotice){
        var resumeStatus=body.querySelector('[data-cbm-newux-status]');
        if(resumeStatus)resumeStatus.textContent=flow.resumeNotice;
        flow.resumeNotice='';
      }
    }

    function renderReview() {
      var html='<p class="cbm-newux-modal__lead">Review the course and class selections that will be saved with this order.</p><div class="cbm-newux-review">';
      if(flow.mode==='none') {
        html+='<div class="cbm-newux-review__item"><div class="cbm-newux-review__copy"><strong>'+escapeHtml(flow.title)+'</strong><span>Online 24/7 — no class date required.</span></div></div>';
      } else {
        catalogCourseIndices(flow.codes).forEach(function(index){
          var sel=flow.selections[index];
          html+='<div class="cbm-newux-review__item"><div class="cbm-newux-review__copy"><strong>'+escapeHtml(courseName(sel.courseId))+'</strong><span>'+escapeHtml(liveLabel(sel.event))+' PT</span></div><button type="button" class="cbm-newux-review__change" data-cbm-newux-review-change="'+index+'">Change date</button></div>';
        });
        if(flow.mode==='package' && /online|internet|24\/7|24 7/i.test(flow.delivery||'')) html+='<div class="cbm-newux-review__item"><div class="cbm-newux-review__copy"><strong>Online 24/7 components</strong><span>Included online courses do not require scheduling.</span></div></div>';
      }
      html+='</div><p class="cbm-newux-modal__status" data-cbm-newux-status></p>';
      body.innerHTML=html;
      body.querySelectorAll('[data-cbm-newux-review-change]').forEach(function(changeButton){
        changeButton.addEventListener('click',function(){
          var index=Number(changeButton.getAttribute('data-cbm-newux-review-change'));
          var selection=flow.selections[index];
          if(!selection||!selection.event)return;
          flow.editReviewIndex=index;
          flow.editDraftSelection={courseId:selection.courseId,event:selection.event};
          flow.codeIndex=index;
          flow.monthByCode=flow.monthByCode||{};
          flow.monthByCode[selection.courseId]=pacificMonthParts(selection.event.start).key;
          setStep('dates');
        });
      });
      next.textContent='Continue to Student Information';
      next.disabled=false;
    }

    function studentValuesFromCart() {
      var a=flow.cart && flow.cart.attributes ? flow.cart.attributes : {};
      var parsed=parseNevadaLicense(a['Nevada License Number']||'');
      var state=a['CE License State']||'Nevada';
      var licenseType=a['CE License Type']||parsed.type||'Salesperson';
      var licenseNumber=a['CE License Number Digits']||parsed.number||'';
      var suffix=a['CE License Suffix']||parsed.suffix||'';
      return {
        type:a['CE Student Type']||'Purchaser',
        state:state,
        licenseType:licenseType,
        licenseNumber:licenseNumber,
        suffix:suffix,
        license:buildNevadaLicense(licenseType,licenseNumber),
        displayLicense:buildNevadaLicenseDisplay(licenseType,licenseNumber,suffix),
        first:a['CE Student First Name']||'',
        last:a['CE Student Last Name']||'',
        email:a['CE Student Email']||''
      };
    }

    function renderStudent() {
      var s=flow.student||studentValuesFromCart();
      s.state=s.state||'Nevada';
      s.licenseType=s.licenseType||'Salesperson';
      s.licenseNumber=String(s.licenseNumber||'');
      s.suffix=String(s.suffix||'').toUpperCase();
      s.license=buildNevadaLicense(s.licenseType,s.licenseNumber);
      s.displayLicense=buildNevadaLicenseDisplay(s.licenseType,s.licenseNumber,s.suffix);
      flow.student=s;
      var different=s.type==='Different Licensee';
      var stateOptions='<option value="Nevada" '+(s.state==='Nevada'?'selected':'')+'>Nevada</option>';
      var typeOptions=
        '<option value="Salesperson" '+(s.licenseType==='Salesperson'?'selected':'')+'>Salesperson</option>'+
        '<option value="Broker-Salesperson" '+(s.licenseType==='Broker-Salesperson'?'selected':'')+'>Broker-Salesperson</option>'+
        '<option value="Broker" '+(s.licenseType==='Broker'?'selected':'')+'>Broker</option>';
      var suffixOptions=
        '<option value="" '+(!s.suffix?'selected':'')+'>None</option>'+
        '<option value="LLC" '+(s.suffix==='LLC'?'selected':'')+'>LLC</option>'+
        '<option value="PC" '+(s.suffix==='PC'?'selected':'')+'>PC</option>'+
        '<option value="CORP" '+(s.suffix==='CORP'?'selected':'')+'>CORP</option>';
      body.innerHTML =
        '<div class="cbm-newux-student__notice">The CE credit from this purchase will be issued to the license entered below.</div>' +
        '<span class="cbm-newux-student__legend">Who should receive the CE credit?</span>' +
        '<div class="cbm-newux-student__mode">' +
          '<label><input type="radio" name="cbm-newux-student-type" value="Purchaser" '+(!different?'checked':'')+'> My license</label>' +
          '<label><input type="radio" name="cbm-newux-student-type" value="Different Licensee" '+(different?'checked':'')+'> For a friend/colleague</label>' +
        '</div>' +
        '<div class="cbm-newux-student__license-grid">' +
          '<div class="cbm-newux-student__field cbm-newux-student__field--state"><label for="CbmNewUxLicenseState">License state</label><select id="CbmNewUxLicenseState" data-field="state">'+stateOptions+'</select></div>' +
          '<div class="cbm-newux-student__field"><label for="CbmNewUxLicenseType">License type *</label><select id="CbmNewUxLicenseType" data-field="licenseType">'+typeOptions+'</select></div>' +
          '<div class="cbm-newux-student__field"><label for="CbmNewUxLicenseNumber">License number *</label><input id="CbmNewUxLicenseNumber" data-field="licenseNumber" inputmode="numeric" pattern="[0-9]*" autocomplete="off" value="'+escapeHtml(s.licenseNumber)+'" placeholder="123456"></div>' +
          '<div class="cbm-newux-student__field"><label for="CbmNewUxLicenseSuffix">Suffix <span class="cbm-newux-student__optional">(optional)</span></label><select id="CbmNewUxLicenseSuffix" data-field="suffix">'+suffixOptions+'</select></div>' +
        '</div>' +
        '<div class="cbm-newux-student__license-preview '+(s.licenseNumber?'is-ready':'')+'" data-cbm-newux-license-preview>' +
          '<span class="cbm-newux-student__license-check" data-cbm-newux-license-check '+(s.licenseNumber?'':'hidden')+'>✓</span>' +
          '<span data-cbm-newux-license-preview-text>'+(s.licenseNumber?'Your license: <strong>'+escapeHtml(s.displayLicense)+'</strong>':'Enter your license number to see your license here.')+'</span>' +
        '</div>' +
        '<a class="cbm-newux-student__lookup" href="'+NRED_URL+'" target="_blank" rel="noopener">Look it up with NRED ↗</a>' +
        '<div data-cbm-newux-alternate '+(different?'':'hidden')+'><p class="cbm-newux-modal__lead cbm-newux-student__alternate-copy">Enter your friend or colleague’s information exactly as it appears on their license.</p><div class="cbm-newux-student__grid">' +
          '<div class="cbm-newux-student__field"><label>Student First Name *</label><input data-field="first" value="'+escapeHtml(s.first)+'"></div>' +
          '<div class="cbm-newux-student__field"><label>Student Last Name *</label><input data-field="last" value="'+escapeHtml(s.last)+'"></div>' +
        '</div><div class="cbm-newux-student__field"><label>Student Email *</label><input type="email" data-field="email" value="'+escapeHtml(s.email)+'"></div></div>' +
        '<p class="cbm-newux-modal__status" data-cbm-newux-status></p>';

      var status=body.querySelector('[data-cbm-newux-status]');
      function setStudentStatus(message) {
        if(status)status.textContent=message||'';
      }
      function updateLicensePreview() {
        s.license=buildNevadaLicense(s.licenseType,s.licenseNumber);
        s.displayLicense=buildNevadaLicenseDisplay(s.licenseType,s.licenseNumber,s.suffix);
        var preview=body.querySelector('[data-cbm-newux-license-preview]');
        var previewText=body.querySelector('[data-cbm-newux-license-preview-text]');
        var previewCheck=body.querySelector('[data-cbm-newux-license-check]');
        if(preview)preview.classList.toggle('is-ready',!!s.licenseNumber);
        if(previewCheck)previewCheck.hidden=!s.licenseNumber;
        if(previewText)previewText.innerHTML=s.licenseNumber?'Your license: <strong>'+escapeHtml(s.displayLicense)+'</strong>':'Enter your license number to see your license here.';
      }

      body.querySelectorAll('input[name="cbm-newux-student-type"]').forEach(function(i){
        i.addEventListener('change',function(){
          flow.student.type=i.value;
          renderStudent();
        });
      });

      var stateSelect=body.querySelector('[data-field="state"]');
      var typeSelect=body.querySelector('[data-field="licenseType"]');
      var suffixSelect=body.querySelector('[data-field="suffix"]');
      var licenseNumberInput=body.querySelector('[data-field="licenseNumber"]');

      if(stateSelect)stateSelect.addEventListener('change',function(){s.state=stateSelect.value||'Nevada';});
      if(typeSelect)typeSelect.addEventListener('change',function(){s.licenseType=typeSelect.value||'Salesperson';setStudentStatus('');updateLicensePreview();});
      if(suffixSelect)suffixSelect.addEventListener('change',function(){s.suffix=String(suffixSelect.value||'').toUpperCase();setStudentStatus('');updateLicensePreview();});

      if(licenseNumberInput) {
        licenseNumberInput.addEventListener('beforeinput',function(event){
          if(event.inputType&&event.inputType.indexOf('insert')===0&&event.data&&!/^\d+$/.test(event.data)){
            event.preventDefault();
            setStudentStatus('Use numbers only for the license number.');
          }
        });
        licenseNumberInput.addEventListener('paste',function(event){
          var pasted=(event.clipboardData||window.clipboardData).getData('text');
          if(!/^\d*$/.test(pasted)){
            event.preventDefault();
            setStudentStatus('Paste only the numeric part of the license number.');
          }
        });
        licenseNumberInput.addEventListener('input',function(){
          if(!/^\d*$/.test(licenseNumberInput.value)){
            licenseNumberInput.value=s.licenseNumber||'';
            setStudentStatus('Use numbers only for the license number.');
            return;
          }
          s.licenseNumber=licenseNumberInput.value;
          setStudentStatus('');
          updateLicensePreview();
        });
      }

      body.querySelectorAll('[data-field="first"],[data-field="last"],[data-field="email"]').forEach(function(i){
        i.addEventListener('input',function(){s[i.getAttribute('data-field')]=i.value;});
      });
      next.textContent='Continue to Cart';
      next.disabled=false;
    }

    function formatCartMoney(cents,currency) {
      var amount=(Number(cents)||0)/100;
      try { return new Intl.NumberFormat('en-US',{style:'currency',currency:currency||'USD'}).format(amount); }
      catch(_) { return '$'+amount.toFixed(2); }
    }

    function catalogCardForCartItem(item) {
      var variantId=String(item&&item.variant_id||item&&item.id||'');
      if(!variantId)return null;
      var buttons=catalog.querySelectorAll('[data-variant-id]');
      for(var i=0;i<buttons.length;i++){
        if(String(buttons[i].getAttribute('data-variant-id')||'')===variantId){
          return buttons[i].closest('[data-product-card]');
        }
      }
      return null;
    }

    function courseMetaForCart(code) {
      var normalizedCode=String(code||'').trim();
      var cards=catalog.querySelectorAll('[data-product-card][data-course-id]');
      for(var i=0;i<cards.length;i++){
        var card=cards[i];
        if(card.getAttribute('data-is-package')==='true')continue;
        if(String(card.getAttribute('data-course-id')||'').trim()!==normalizedCode)continue;
        var rawDesignations=splitValues(card,'data-designation-values',designationKey);
        return {
          title:productTitle(card,null)||courseName(normalizedCode),
          designation:rawDesignations.length?labelDesignation(rawDesignations[0]):''
        };
      }
      return {title:courseName(normalizedCode),designation:''};
    }

    function cartItemIncludesOnline(item) {
      var card=catalogCardForCartItem(item);
      var delivery=normalize(card&&card.getAttribute('data-delivery-method')||'');
      if(delivery.indexOf('online')!==-1||delivery.indexOf('internet')!==-1||delivery.indexOf('24')!==-1||delivery.indexOf('anytime')!==-1)return true;
      var description=normalize(item&&item.product_description||'');
      return description.indexOf('online')!==-1||description.indexOf('internet')!==-1||description.indexOf('24 7')!==-1||description.indexOf('anytime')!==-1;
    }

    function onlineAnytimeCartNote(item) {
      if(!cartItemIncludesOnline(item))return '';
      return '<div class="cbm-newux-modal-cart__online-note"><strong>Online 24/7 courses</strong><span>No booking is required. You can start these courses anytime.</span></div>';
    }

    function cartScheduleMarkup(item) {
      var props=item&&item.properties ? item.properties : {};
      var manifest=null;
      if(props['_CE Booking Manifest']){
        try { manifest=JSON.parse(props['_CE Booking Manifest']); } catch(_) { manifest=null; }
      }
      if(Array.isArray(manifest)&&manifest.length){
        return '<details class="cbm-newux-modal-cart__schedule"><summary>'+manifest.length+' live '+(manifest.length===1?'class':'classes')+' scheduled</summary><div class="cbm-newux-modal-cart__schedule-list">'+manifest.map(function(entry){
          var code=String(entry.course_code||'').trim();
          var meta=courseMetaForCart(code);
          var parts=[code||'Live class'];
          if(meta.title&&meta.title!==code)parts.push(meta.title);
          if(meta.designation)parts.push(meta.designation);
          return '<div class="cbm-newux-modal-cart__schedule-row"><strong>'+parts.map(escapeHtml).join(' <span aria-hidden="true">|</span> ')+'</strong><span>'+escapeHtml(entry.live_class||'Date selected')+'</span></div>';
        }).join('')+'</div></details>'+onlineAnytimeCartNote(item);
      }
      if(props['Live Class']){
        return '<div class="cbm-newux-modal-cart__schedule-single"><strong>Live Zoom</strong><span>'+escapeHtml(props['Live Class'])+' PT</span></div>'+onlineAnytimeCartNote(item);
      }
      if(cartItemIncludesOnline(item)){
        return onlineAnytimeCartNote(item);
      }
      return '';
    }

    function cartStudentMarkup(cart) {
      var attrs=cart&&cart.attributes ? cart.attributes : {};
      var base=String(attrs['Nevada License Number']||'').trim();
      var suffix=String(attrs['CE License Suffix']||'').trim().toUpperCase();
      var display=base+(base&&suffix?'.'+suffix:'');
      var different=attrs['CE Student Type']==='Different Licensee';
      var name=different ? (String(attrs['CE Student First Name']||'').trim()+' '+String(attrs['CE Student Last Name']||'').trim()).trim() : 'My license';
      return '<div class="cbm-newux-modal-cart__student"><div><span>CE CREDIT</span><strong>'+escapeHtml(name||'Student')+'</strong></div><b>'+escapeHtml(display||'License saved')+'</b></div>';
    }

    function cartItemBookingValid(item) {
      var props=item&&item.properties ? item.properties : {};
      if(props['_CE Booking Manifest']){
        var manifest=null;
        try { manifest=JSON.parse(props['_CE Booking Manifest']); } catch(_) { return false; }
        var expected=String(props['_CE Live Course Codes']||'').split('||').map(function(code){return code.trim();}).filter(Boolean);
        if(!Array.isArray(manifest)||!expected.length||manifest.length!==expected.length)return false;
        return expected.every(function(code,index){
          var entry=manifest[index]||{};
          var event=upcomingEvents(code).find(function(candidate){return String(candidate.session_id||'')===String(entry.session_id||'');});
          return !!event&&String(entry.course_code||'')===code&&String(entry.start||'')===String(event.start||'')&&String(entry.end||'')===String(event.end||'');
        });
      }
      if(props['_CE Course ID']||props['_CE Session ID']){
        var code=String(props['_CE Course ID']||'');
        var sessionId=String(props['_CE Session ID']||'');
        var event=upcomingEvents(code).find(function(candidate){return String(candidate.session_id||'')===sessionId;});
        return !!event&&String(props['_Class Start']||'')===String(event.start||'')&&String(props['_Class End']||'')===String(event.end||'');
      }
      if(Number(props['_CE Live Course Count']||0)>0)return false;
      return true;
    }

    function cartNeedsBookingValidation(cart) {
      return (cart&&cart.items||[]).some(function(item){
        var props=item&&item.properties ? item.properties : {};
        return !!(props['_CE Booking Manifest']||props['_CE Course ID']||props['_CE Session ID']||Number(props['_CE Live Course Count']||0)>0);
      });
    }

    function renderCart() {
      var cart=flow.cart||{};
      var items=cart.items||[];
      var currency=cart.currency||'USD';
      var lines=items.map(function(item){
        var finalLine=Number(item.final_line_price!=null?item.final_line_price:item.line_price)||0;
        var originalLine=Number(item.original_line_price!=null?item.original_line_price:finalLine)||0;
        var price=originalLine>finalLine?'<span class="cbm-newux-modal-cart__was">'+formatCartMoney(originalLine,currency)+'</span><strong>'+formatCartMoney(finalLine,currency)+'</strong>':'<strong>'+formatCartMoney(finalLine,currency)+'</strong>';
        return '<article class="cbm-newux-modal-cart__item"><div class="cbm-newux-modal-cart__item-head"><h3>'+escapeHtml(item.product_title||item.title||'Course')+'</h3><div class="cbm-newux-modal-cart__price">'+price+'</div></div>'+cartScheduleMarkup(item)+'<button type="button" class="cbm-newux-modal-cart__remove" data-cbm-newux-cart-remove="'+escapeHtml(item.key||'')+'">Remove</button></article>';
      }).join('');
      var discount=Number(cart.total_discount)||0;
      var original=Number(cart.original_total_price!=null?cart.original_total_price:cart.total_price)||0;
      var total=Number(cart.total_price)||0;
      body.innerHTML='<p class="cbm-newux-modal__lead">Your courses are saved in your cart. Add more courses or continue to checkout when you are ready.</p>'+cartStudentMarkup(cart)+(items.length?'<div class="cbm-newux-modal-cart__items">'+lines+'</div>':'<div class="cbm-newux-modal-cart__empty"><strong>Your cart is empty.</strong><span>Add a course to continue.</span></div>')+(items.length?'<div class="cbm-newux-modal-cart__totals">'+(discount>0?'<div><span>Original total</span><span>'+formatCartMoney(original,currency)+'</span></div><div class="is-savings"><span>Savings</span><span>-'+formatCartMoney(discount,currency)+'</span></div>':'')+'<div class="is-total"><strong>Total</strong><strong>'+formatCartMoney(total,currency)+'</strong></div></div>':'')+'<p class="cbm-newux-modal-cart__status" data-cbm-newux-cart-status></p>';

      body.querySelectorAll('[data-cbm-newux-cart-remove]').forEach(function(button){
        button.addEventListener('click',function(){
          var key=button.getAttribute('data-cbm-newux-cart-remove');
          var status=body.querySelector('[data-cbm-newux-cart-status]');
          if(!key)return;
          button.disabled=true;
          if(status)status.textContent='Updating your cart...';
          cartGate(function(){
            return fetch(rootUrl('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});
          }).then(function(response){
            if(!response.ok)throw new Error('Unable to remove that course right now.');
            return response.json();
          }).then(function(cart){
            flow.cart=cart;
            syncThemeCartState(cart,button);
            renderCart();
          }).catch(function(err){
            if(status)status.textContent=err.message||'Unable to update your cart.';
            button.disabled=false;
          });
        });
      });

      next.textContent='Continue to Checkout';
      next.disabled=!items.length;
    }

    function cartStudentReady(cart) {
      var attrs=cart&&cart.attributes ? cart.attributes : {};
      var license=String(attrs['Nevada License Number']||'').trim();
      if(!license)return false;
      if(attrs['CE Student Type']==='Different Licensee'){
        return !!(
          String(attrs['CE Student First Name']||'').trim() &&
          String(attrs['CE Student Last Name']||'').trim() &&
          String(attrs['CE Student Email']||'').trim()
        );
      }
      return true;
    }

    function submitCartCheckout() {
      var cart=flow.cart||{};
      var status=body.querySelector('[data-cbm-newux-cart-status]');
      if(!cart.items||!cart.items.length)return;
      if(!cartStudentReady(cart)){
        if(status)status.textContent='Student information needs review before checkout. Open the full cart from the header to complete it.';
        next.disabled=false;
        next.textContent='Continue to Checkout';
        return;
      }
      next.disabled=true;
      next.textContent='Checking your cart...';
      var validation=cartNeedsBookingValidation(cart)?loadSessions(catalog):Promise.resolve();
      validation.then(function(){
        if(!(cart.items||[]).every(cartItemBookingValid)){
          if(status)status.textContent='One or more selected class dates are no longer valid. Use the cart page to update the class date before checkout.';
          next.disabled=false;
          next.textContent='Continue to Checkout';
          return;
        }
        window.location.href=rootUrl('checkout');
      }).catch(function(){
        if(status)status.textContent='We could not validate your selected class dates right now. Please try again.';
        next.disabled=false;
        next.textContent='Continue to Checkout';
      });
    }

    function render() {
      body.scrollTop=0;
      if(flow.step==='dates')renderDates();
      if(flow.step==='review')renderReview();
      if(flow.step==='student')renderStudent();
      if(flow.step==='cart')renderCart();
    }

    function validateStudent() {
      var s=flow.student||{};
      s.state=String(s.state||'Nevada').trim();
      s.licenseType=String(s.licenseType||'').trim();
      s.licenseNumber=String(s.licenseNumber||'').trim();
      s.suffix=String(s.suffix||'').trim().toUpperCase();
      s.first=String(s.first||'').trim();
      s.last=String(s.last||'').trim();
      s.email=String(s.email||'').trim();
      var status=body.querySelector('[data-cbm-newux-status]');
      function fail(msg,field){if(status)status.textContent=msg;var input=body.querySelector('[data-field="'+field+'"]');if(input)input.focus();return false;}
      if(s.state!=='Nevada')return fail('Nevada is the only license state currently supported.','state');
      if(['Salesperson','Broker-Salesperson','Broker'].indexOf(s.licenseType)===-1)return fail('Choose your Nevada license type.','licenseType');
      if(!s.licenseNumber)return fail('Enter the numeric part of the license number.','licenseNumber');
      if(!/^\d+$/.test(s.licenseNumber))return fail('Use numbers only for the license number.','licenseNumber');
      if(['','LLC','PC','CORP'].indexOf(s.suffix)===-1)return fail('Choose a valid license suffix.','suffix');
      s.license=buildNevadaLicense(s.licenseType,s.licenseNumber);
      s.displayLicense=buildNevadaLicenseDisplay(s.licenseType,s.licenseNumber,s.suffix);
      if(s.type==='Different Licensee'){
        if(!s.first)return fail('Enter the student first name as it appears on the license.','first');
        if(!s.last)return fail('Enter the student last name as it appears on the license.','last');
        var emailInput=body.querySelector('[data-field="email"]');
        if(!s.email||!emailInput||!emailInput.checkValidity())return fail('Enter a valid email address for the student.','email');
      }
      flow.student=s;
      return true;
    }

    function itemProperties() {
      if(flow.mode==='individual') {
        var e=flow.selections[0].event;
        return {
          'Live Class':liveLabel(e),
          '_CE Course ID':flow.codes[0],
          '_CE Session ID':e.session_id||'',
          '_Class Start':e.start||'',
          '_Class End':e.end||'',
          '_Class Timezone':e.timezone||(sessionCache&&sessionCache.timezone)||'America/Los_Angeles',
          '_Calendar Event ID':e.calendar_event_id||''
        };
      }
      if(flow.mode==='package') {
        var manifest=flow.selections.map(function(sel){
          var e=sel.event;
          return {course_code:sel.courseId,session_id:e.session_id||'',live_class:liveLabel(e),start:e.start||'',end:e.end||'',timezone:e.timezone||(sessionCache&&sessionCache.timezone)||'America/Los_Angeles',calendar_event_id:e.calendar_event_id||''};
        });
        var p={
          '_CE Booking Manifest':JSON.stringify(manifest),
          '_CE Live Course Codes':manifest.map(function(x){return x.course_code;}).join('||'),
          '_CE Session IDs':manifest.map(function(x){return x.session_id;}).join('||'),
          '_CE Live Course Count':String(flow.codes.length),
          '_CE Selected Session Count':String(manifest.length)
        };
        manifest.forEach(function(x){p['Live Class - '+x.course_code]=x.live_class;});
        return p;
      }
      return {};
    }

    function finish() {
      if(!validateStudent())return;
      var status=body.querySelector('[data-cbm-newux-status]');
      if(status)status.textContent='Saving your selections...';
      next.disabled=true; back.disabled=true;
      var item={id:Number(flow.variantId),quantity:1};
      var props=itemProperties();
      if(Object.keys(props).length)item.properties=props;

      saveStudentAttributes(flow.student)
        .then(function(){
          if(flow.itemAdded)return null;
          return addItem(item).then(function(){flow.itemAdded=true;});
        })
        .then(function(){
          clearPurchaseDraft(flow.variantId);
          notifyPurchaseDraftState(flow.variantId);
          return emitCartState(flow.button);
        })
        .then(function(cart){
          if(!cart)throw new Error('Your course is in the cart, but the cart view could not refresh. Close this window and use the cart icon to continue.');
          flow.cart=cart;
          back.disabled=false;
          setStep('cart');
        })
        .catch(function(err){
          if(status)status.textContent=err.message||'Unable to save your selections right now.';
          next.disabled=!!flow.itemAdded;
          back.disabled=false;
        });
    }

    next.addEventListener('click',function(){
      if(!flow)return;
      if(flow.step==='dates'){
        var editingReviewDate=typeof flow.editReviewIndex==='number' && flow.editReviewIndex===flow.codeIndex;
        if(editingReviewDate){
          if(!flow.editDraftSelection)return;
          flow.selections[flow.codeIndex]=flow.editDraftSelection;
          flow.editReviewIndex=null;
          flow.editDraftSelection=null;
          setStep('review');return;
        }
        if(!flow.selections[flow.codeIndex])return;
        var nextMissing=catalogMissingIndex(flow,flow.codeIndex);
        if(nextMissing>=0){flow.codeIndex=nextMissing;renderDates();return;}
        setStep('review');return;
      }
      if(flow.step==='review'){setStep('student');return;}
      if(flow.step==='student'){finish();return;}
      if(flow.step==='cart'){submitCartCheckout();}
    });
    back.addEventListener('click',function(){
      if(!flow)return;
      if(flow.step==='dates' && typeof flow.editReviewIndex==='number'){
        flow.editReviewIndex=null;
        flow.editDraftSelection=null;
        setStep('review');return;
      }
      if(flow.step==='student'){setStep('review');return;}
      if(flow.step==='review'){
        if(flow.mode==='none')return;
        flow.codeIndex=catalogCourseIndices(flow.codes).slice(-1)[0]||0;
        setStep('dates');
      }
    });

    function openExistingCart(trigger, checkoutNow) {
      getCart().then(function(cart){
        if(!cart||!cart.items||!cart.items.length){
          window.location.href=rootUrl('cart');
          return;
        }
        flow={
          button:trigger,
          card:trigger&&trigger.closest?trigger.closest('[data-product-card]'):null,
          variantId:'',
          mode:'none',
          codes:[],
          title:'Your cart',
          delivery:'',
          selections:[],
          monthByCode:{},
          editReviewIndex:null,
          editDraftSelection:null,
          itemAdded:true,
          codeIndex:0,
          cart:cart,
          student:null,
          step:'cart'
        };
        modal.hidden=false;
        document.body.classList.add('cbm-newux-modal-open');
        setStep('cart');
        var closeButton=modal.querySelector('.cbm-newux-modal__close');
        if(closeButton&&typeof closeButton.focus==='function')closeButton.focus();
        if(checkoutNow)window.setTimeout(submitCartCheckout,0);
      }).catch(function(){
        window.location.href=rootUrl('cart');
      });
    }

    catalog.addEventListener('click',function(event){
      var cartAction=event.target.closest('[data-cbm-view-cart],[data-cbm-continue-checkout]');
      if(cartAction){
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openExistingCart(cartAction,cartAction.hasAttribute('data-cbm-continue-checkout'));
        return;
      }

      var button=event.target.closest('button');
      if(!button)return;
      var isAdd=button.matches('[data-details-add-to-cart]') || String(button.className||'').indexOf('cbm-course-catalog__add-')!==-1;
      if(!isAdd)return;
      if(button.dataset.cbmInCart==='true'||button.disabled)return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var card=button.closest('[data-product-card]');
      var variantId=button.getAttribute('data-variant-id');
      if(!variantId)return;
      var mode=bookingMode(button);
      var codes=mode==='individual'?[button.getAttribute('data-course-id')||'']:mode==='package'?packageCodes(button):[];
      var launch=function(){
        getCart().then(function(cart){
          if((cart.items||[]).some(function(i){return String(i.variant_id)===String(variantId);})){
            clearPurchaseDraft(variantId);
            notifyPurchaseDraftState(variantId);
            openExistingCart(button,false);
            return;
          }
          var baseFlow={button:button,card:card,variantId:variantId,mode:mode,codes:codes,title:productTitle(card,button),delivery:(button.getAttribute('data-cbm-newux-delivery')||(card&&card.getAttribute('data-delivery-method'))||''),selections:[],monthByCode:{},editReviewIndex:null,editDraftSelection:null,itemAdded:false,codeIndex:0,cart:cart,student:null,step:mode==='none'?'review':'dates'};
          baseFlow.codeIndex=catalogCourseIndices(codes)[0]||0;
          flow=hydrateDraft(baseFlow,readPurchaseDraft(variantId));
          modal.hidden=false;
          document.body.classList.add('cbm-newux-modal-open');
          setStep(flow.step);
          modal.querySelector('.cbm-newux-modal__close').focus();
        }).catch(function(){});
      };
      if(mode==='none')launch();
      else loadSessions(catalog).then(launch).catch(function(err){
        alert(err.message||'Class schedule is temporarily unavailable.');
      });
    },true);
    notifyPurchaseDraftState('');
  }

  function initCartPage() {
    var cartItems=document.querySelector('cart-items[data-cbm-newux-cart-page]');
    if(!cartItems||cartItems.dataset.cbmNewUxReady==='true')return;
    cartItems.dataset.cbmNewUxReady='true';
    var url=cartItems.getAttribute('data-cbm-live-schedule-url')||'';
    var busy=false;
    function properties(row) {
      var data=JSON.parse(row.querySelector('[data-cbm-cart-properties]').textContent||'{}');
      var props=Array.isArray(data)?Object.fromEntries(data):data;
      Object.keys(props).forEach(function(key){
        var decoder=document.createElement('textarea');decoder.innerHTML=String(props[key]);props[key]=decoder.value;
      });
      return props;
    }
    function entries(props) {
      if(props['_CE Booking Manifest']){
        var manifest=JSON.parse(props['_CE Booking Manifest']);
        var codes=String(props['_CE Live Course Codes']||'').split('||').filter(Boolean);
        var ids=String(props['_CE Session IDs']||'').split('||').filter(Boolean);
        if(!Array.isArray(manifest)||!codes.length||new Set(codes).size!==codes.length||manifest.length!==codes.length||ids.length!==codes.length||Number(props['_CE Live Course Count'])!==codes.length||Number(props['_CE Selected Session Count'])!==codes.length||manifest.some(function(e,i){return e.course_code!==codes[i]||String(e.session_id)!==ids[i];}))throw new Error('The saved package dates need attention.');
        return manifest;
      }
      return props['_CE Course ID']?[{course_code:props['_CE Course ID'],session_id:props['_CE Session ID'],live_class:props['Live Class'],start:props['_Class Start'],end:props['_Class End']}]:[];
    }
    function loadCartSchedule() {
      if(sessionCache)return Promise.resolve(sessionCache);
      if(!url)return Promise.reject(new Error('Class schedule is unavailable.'));
      sessionPromise=sessionPromise||fetch(url,{credentials:'same-origin',cache:'no-store'}).then(function(r){if(!r.ok)throw new Error('Unable to load class dates.');return r.json();}).then(function(d){sessionCache=d;return d;}).catch(function(err){sessionPromise=null;throw err;});
      return sessionPromise;
    }
    function renderRows() {
      cartItems.querySelectorAll('[data-cbm-newux-cart-line]').forEach(function(row){
        if(row.querySelector('.cbm-newux-cart-booking'))return;
        var host=document.createElement('div');host.className='cbm-newux-cart-booking';
        var required=(row.dataset.cbmRequiredCodes||'').split('||').filter(Boolean);
        try {
          var booked=entries(properties(row));
          if(!Array.isArray(booked))throw new Error('Invalid bookings');
          var rank = function(code) { return code === 'CE.7027000-RE' ? -1 : code === 'CE.7085000-RE' ? 1 : 0; };
          booked.slice().sort(function(a,b) { return rank(a.course_code)-rank(b.course_code); }).forEach(function(entry){
            var line=document.createElement('div');line.className='cbm-newux-cart-booking__row';
            var labels = {'CE.7027000-RE':'Agency','CE.7037000-RE':'Ethics','CE.7028000-RE':'Contracts 1','CE.7029000-RE':'Contracts 2','CE.7386000-RE':'Law & Legislation','CE.7085000-RE':'Risk Reduction'};
            var label = labels[entry.course_code] || 'Live class';
            line.innerHTML='<span class="cbm-cart-class-copy"><span class="cbm-cart-class-designation">'+escapeHtml(label+' · '+(entry.course_code||''))+'</span><strong>'+escapeHtml(courseName(entry.course_code)||'Live class')+'</strong><span class="cbm-cart-date">'+escapeHtml(entry.live_class||'Choose a class date')+'</span></span><button type="button" class="cbm-newux-cart-change" data-cbm-newux-change-date data-course-code="'+escapeHtml(entry.course_code||'')+'" aria-expanded="false">Change date</button>';
            host.appendChild(line);
          });
          if(required.some(function(code){return !booked.some(function(e){return e.course_code===code&&e.live_class&&e.start;});}))throw new Error('Missing bookings');
          if(!booked.length)host.innerHTML='<div class="cbm-cart-online-note"><strong>Online 24/7</strong><span>No class date required.</span></div>';
          else if(/online|internet|24\/7|24 7/i.test(row.dataset.cbmDeliveryMethod||'')){
            var note=document.createElement('div');note.className='cbm-cart-online-note';note.innerHTML='<strong>Online 24/7 included.</strong><span>No class date required. Start anytime after enrollment.</span>';host.appendChild(note);
          }
        }catch(_){
          var warning=document.createElement('p');warning.textContent='Class dates need attention. Open this course to complete your selection before checkout.';host.appendChild(warning);
        }
        row.querySelector('.cart-item__details').appendChild(host);
      });
    }
    renderRows();
    new MutationObserver(renderRows).observe(cartItems,{childList:true,subtree:true});
    loadCartSchedule().then(function(){
      cartItems.querySelectorAll('[data-cbm-newux-change-date]').forEach(function(button){
        var code=button.dataset.courseCode,title=courseName(code);
        if(title!==code)button.closest('.cbm-newux-cart-booking__row').querySelector('strong').textContent=title;
      });
    }).catch(function(){});

    cartItems.addEventListener('click',async function(event){
      var button=event.target.closest('[data-cbm-newux-change-date]');
      if(!button||busy)return;
      var row=button.closest('[data-cbm-newux-cart-line]'),line=button.closest('.cbm-newux-cart-booking__row');
      var old=line.querySelector('.cbm-cart-date-editor');
      if(old){old.remove();button.setAttribute('aria-expanded','false');return;}
      var editor=document.createElement('div');editor.className='cbm-cart-date-editor';editor.setAttribute('role','group');editor.setAttribute('aria-label','Change class date');
      editor.innerHTML='<p role="status">Loading available dates…</p>';line.appendChild(editor);button.setAttribute('aria-expanded','true');
      try {
        await loadCartSchedule();
        var code=button.dataset.courseCode,available=upcomingEvents(code);
        editor.innerHTML='<label>Available dates (Pacific Time)<select aria-label="Available dates for '+escapeHtml(code)+'"><option value="">Choose a date</option>'+available.map(function(e,i){return '<option value="'+i+'">'+escapeHtml(liveLabel(e)+' PT')+'</option>';}).join('')+'</select></label><div class="cbm-cart-editor-actions"><button type="button" data-save disabled>Save date</button><button type="button" data-cancel>Cancel</button></div><p role="status">'+(available.length?'Your current date stays saved until you choose Save date.':'No future sessions are available. Your current date is unchanged.')+'</p>';
        var select=editor.querySelector('select'),save=editor.querySelector('[data-save]'),status=editor.querySelector('[role="status"]');
        select.addEventListener('change',function(){save.disabled=select.value==='';});
        editor.querySelector('[data-cancel]').addEventListener('click',function(){if(busy)return;editor.remove();button.setAttribute('aria-expanded','false');button.focus();});
        select.focus();
        save.addEventListener('click',async function(){
          if(busy||select.value==='')return;
          busy=true;save.disabled=true;select.disabled=true;status.textContent='Saving your date…';
          try {
            var chosen=available[Number(select.value)];
            if(!chosen||new Date(chosen.start).getTime()<=Date.now())throw new Error('This session is no longer available. Choose another date.');
            await cartGate(async function(){
              var cart=await getCart(),item=cart.items.find(function(i){return i.key===row.dataset.cbmLineKey;});
              if(!item)throw new Error('Your cart changed. Refresh this page before editing dates.');
              var props=Object.assign({},item.properties),manifest=entries(props);
              var target=manifest.find(function(e){return String(e.course_code)===code;});
              if(!target)throw new Error('The saved booking could not be found. Refresh this page.');
              Object.assign(target,{session_id:chosen.session_id,live_class:liveLabel(chosen)+' PT',start:chosen.start,end:chosen.end,timezone:chosen.timezone||sessionCache.timezone||'America/Los_Angeles',calendar_event_id:chosen.calendar_event_id||''});
              if(props['_CE Booking Manifest']){
                props['_CE Booking Manifest']=JSON.stringify(manifest);
                props['_CE Session IDs']=manifest.map(function(e){return e.session_id||'';}).join('||');
                props['_CE Selected Session Count']=String(manifest.length);
                props['Live Class - '+code]=target.live_class;
              }else{
                Object.assign(props,{'Live Class':target.live_class,'_CE Course ID':code,'_CE Session ID':target.session_id,'_Class Start':target.start,'_Class End':target.end,'_Class Timezone':target.timezone,'_Calendar Event ID':target.calendar_event_id});
              }
              var response=await fetch(rootUrl('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties:props})});
              if(!response.ok)throw new Error('Unable to save this date. Your current selection is still shown; refresh before retrying.');
              var updated=await response.json();
              if(!Array.isArray(updated.items))throw new Error('Refresh your cart to confirm the saved date.');
            });
            window.location.reload();
          }catch(err){status.textContent=err.message;busy=false;save.disabled=false;select.disabled=false;}
        });
      }catch(err){editor.querySelector('[role="status"]').textContent=err.message;}
    });

    async function validateBookings() {
      if(busy)throw new Error('Wait for your date change to finish.');
      var cart=await getCart();
      if(!cart.items.length)throw new Error('Your cart is empty.');
      var rows=Array.from(cartItems.querySelectorAll('[data-cbm-newux-cart-line]'));
      if(rows.length!==cart.items.length)throw new Error('Your cart changed. Refresh to review it before continuing.');
      for(var item of cart.items){
        var row=rows.find(function(r){return r.dataset.cbmLineKey===item.key;});
        if(!row)throw new Error('Your cart changed. Refresh to review it before continuing.');
        var required=(row.dataset.cbmRequiredCodes||'').split('||').filter(Boolean),booked;
        try{booked=entries(item.properties||{});}catch(_){throw new Error('Review the class dates for '+item.product_title+'.');}
        if(!Array.isArray(booked))throw new Error('Review your class dates.');
        if(required.length||booked.length){
          await loadCartSchedule();
          if(required.some(function(code){return booked.filter(function(e){return String(e.course_code)===code;}).length!==1;}))throw new Error('Complete all required class dates for '+item.product_title+'.');
          for(var entry of booked){
            if(!entry.session_id||!upcomingEvents(entry.course_code).some(function(e){return String(e.session_id)===String(entry.session_id)&&e.start===entry.start;}))throw new Error('Choose an available date for '+(entry.course_code||item.product_title)+'.');
          }
        }
      }
      return cart;
    }
    var student=document.querySelector('#CbmCartStudent'),form=student&&student.querySelector('form');
    function updateStudent() {
      var different=form.elements.type.value==='Different Licensee';
      student.querySelector('[data-cbm-cart-alternate]').hidden=!different;
      ['first','last','email'].forEach(function(name){form.elements[name].required=different;});
      student.querySelector('[data-cbm-cart-license-preview]').textContent=buildNevadaLicenseDisplay(form.elements.licenseType.value,form.elements.licenseNumber.value,form.elements.suffix.value);
    }
    document.addEventListener('click',async function(event){
      var button=event.target.closest('[data-cbm-cart-continue]');if(!button)return;
      var errors=document.querySelector('#cart-errors');button.disabled=true;errors.textContent='';
      try{
        var cart=await validateBookings(),a=cart.attributes||{},parsed=parseNevadaLicense(a['Nevada License Number']);
        if(!form.dataset.loaded){
          var values={type:a['CE Student Type']||'Purchaser',state:'Nevada',licenseType:a['CE License Type']||parsed.type||'Salesperson',licenseNumber:a['CE License Number Digits']||parsed.number||'',suffix:a['CE License Suffix']||parsed.suffix||'',first:a['CE Student First Name']||'',last:a['CE Student Last Name']||'',email:a['CE Student Email']||''};
          Object.keys(values).forEach(function(k){form.elements[k].value=values[k];});form.dataset.loaded='true';
        }
        student.hidden=false;updateStudent();student.scrollIntoView({behavior:'smooth',block:'start'});student.querySelector('h2').focus();
      }catch(err){errors.textContent=err.message;}finally{button.disabled=false;}
    });
    if(form){
      form.addEventListener('input',updateStudent);
      form.addEventListener('change',updateStudent);
      form.addEventListener('submit',async function(event){
        event.preventDefault();if(busy)return;
        var button=form.querySelector('button[type="submit"]'),status=form.querySelector('[data-cbm-student-status]');
        if(!form.reportValidity())return;
        var values=Object.fromEntries(new FormData(form));
        Object.keys(values).forEach(function(key){values[key]=values[key].trim();});
        if(values.type==='Different Licensee'&&(!values.first||!values.last||!values.email)){status.textContent='Complete the student name and email.';return;}
        if(!/^\d+$/.test(values.licenseNumber)||!['Salesperson','Broker-Salesperson','Broker'].includes(values.licenseType)){status.textContent='Enter a valid Nevada license type and numeric license number.';return;}
        button.disabled=true;status.textContent='Saving student information…';
        try{
          await validateBookings();busy=true;
          var saved=await saveStudentAttributes(values);
          if(!saved.attributes||saved.attributes['Nevada License Number']!==buildNevadaLicense(values.licenseType,values.licenseNumber))throw new Error('Please retry saving student information before checkout.');
          window.location.assign(rootUrl('checkout'));
        }catch(err){status.textContent=err.message;button.disabled=false;busy=false;}
      });
    }
    if (student && form && window.location.hash === '#student-information') {
      document.querySelector('[data-cbm-cart-continue]')?.click();
    }
    var cartForm=document.querySelector('form#cart');
    if(cartForm)cartForm.addEventListener('submit',function(event){event.preventDefault();document.querySelector('[data-cbm-cart-continue]')?.click();});
    document.addEventListener('submit',function(event){
      if(!event.target.matches('[data-cbm-newux-discount-form]'))return;
      event.preventDefault();var code=event.target.querySelector('[name="discount"]').value.trim();
      if(code)window.location.href=rootUrl('discount/')+encodeURIComponent(code)+'?redirect='+encodeURIComponent(rootUrl('cart'));
    });
  }


  function initHeroScrollCue() {
    if (document.querySelector('[data-cbm-hero-scroll-cue]')) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var heroSelectors = [
      '.cbm-ce-product-hero',
      '.hero-flexible',
      '.cbm-compact-hero',
      '.cbm-ce-hub-hero',
      '.collection-hero',
      '.banner'
    ];
    var hero = null;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    function isUsable(element) {
      if (!element) return false;
      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 80;
    }

    heroSelectors.some(function (selector) {
      var candidates = Array.from(main.querySelectorAll(selector));
      hero = candidates.find(function (candidate) {
        if (!isUsable(candidate)) return false;
        return candidate.getBoundingClientRect().top < viewportHeight * 0.75;
      }) || null;
      return Boolean(hero);
    });

    if (!hero) return;

    function nextUsableSibling(element) {
      var sibling = element ? element.nextElementSibling : null;
      while (sibling) {
        if (!sibling.matches('script, style') && isUsable(sibling)) return sibling;
        sibling = sibling.nextElementSibling;
      }
      return null;
    }

    var target = nextUsableSibling(hero);
    if (!target) {
      var heroSection = hero.closest('.shopify-section');
      target = nextUsableSibling(heroSection);
    }
    if (!target) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cbm-hero-scroll-cue';
    button.setAttribute('data-cbm-hero-scroll-cue', '');
    button.setAttribute('aria-label', 'Scroll down to the first content section');
    button.setAttribute('aria-hidden', 'true');
    button.tabIndex = -1;
    button.innerHTML = '<span class="cbm-hero-scroll-cue__label">Scroll down</span><span class="cbm-hero-scroll-cue__arrow" aria-hidden="true">↓</span>';
    document.body.appendChild(button);

    var revealReady = false;
    var dismissed = false;
    var ticking = false;

    function targetIsOneThirdVisible() {
      var rect = target.getBoundingClientRect();
      var height = window.innerHeight || document.documentElement.clientHeight || 1;
      if (rect.bottom <= 0) return true;
      var visibleHeight = Math.max(0, Math.min(rect.bottom, height) - Math.max(rect.top, 0));
      var comparisonHeight = Math.max(1, Math.min(rect.height, height));
      return visibleHeight / comparisonHeight >= 0.33;
    }

    function setVisible(visible) {
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
    }

    function updateVisibility() {
      if (targetIsOneThirdVisible()) dismissed = true;
      setVisible(revealReady && !dismissed);
      ticking = false;
    }

    function requestVisibilityUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }

    function stickyHeaderOffset() {
      var header = document.querySelector('.section-header');
      if (!header) return 0;
      var style = window.getComputedStyle(header);
      if (style.position !== 'sticky' && style.position !== 'fixed') return 0;
      return Math.min(header.getBoundingClientRect().height || 0, 180);
    }

    button.addEventListener('click', function () {
      dismissed = true;
      setVisible(false);
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = target.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset() - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);

    window.setTimeout(function () {
      revealReady = true;
      updateVisibility();
    }, 700);

    updateVisibility();
  }

  function init() {
    initHomeFinder();
    initCatalog();
    initCartPage();
    initHeroScrollCue();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();

